/** 2026-04-10 12:20:12 +0100 **/
const shopMasterObjectData = [
	{
		"id": 157,
		"shop_code": 88,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "London",
		"has_members": false,
		"is_flagship": true,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 51.513494,
		"longitude": -0.145015,
		"google_business_url": "https://www.google.com/maps/place/ISSEY+MIYAKE+%2F+LONDON+10+BROOK/@51.513438,-0.1472047,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x6aea1746d415f122!8m2!3d51.513438!4d-0.145016?",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/10Brook_2018jun18_01_dece4f8c-5938-4208-a233-18b5b700e392.jpg?v=1676645686",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 1,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "IM MEN",
		"brand3": "132 5. ISSEY MIYAKE",
		"brand4": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand5": "A-POC ABLE ISSEY MIYAKE",
		"brand6": "BAO BAO ISSEY MIYAKE",
		"brand7": "HaaT",
		"brand8": "ISSEY MIYAKE PARFUMS",
		"brand9": "ISSEY MIYAKE WATCH",
		"brand10": "ISSEY MIYAKE EYES",
		"brand11": "ISSEY MIYAKE | MOLESKINE",
		"brand12": "ISSEY MIYAKE FOOT",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ロンドン,伦敦,メイフェア,ボンドストリート,オックスフォードサーカス,Mayfair,BondStreet,OxfordCircus,梅费尔,离邦德街,牛津广场",
		"name": "ISSEY MIYAKE / LONDON 10 BROOK",
		"tel": "+44-20-7851-4620",
		"fax": "",
		"zipcode": "-",
		"address": "10 Brook Street, London, W1S 1BG",
		"description": "A flagship store carrying multiple brands from ISSEY MIYAKE INC. on Brook Street in Mayfair, London. Space designer Tokujin Yoshioka restored a former bank to its original structure, leaving the old beams, walls and some of the textures and contrasting them with blue dyed aluminum to create a store where history meets the future.",
		"store_hours": "<p>Business hours 10:00 - 18:00</p>\n<p>Thursday 10:00 - 19:00</p>\n<p>Sunday 12:00 - 18:00</p>",
		"description_note": ""
	},
	{
		"id": 158,
		"shop_code": 89,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "London",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 51.512978,
		"longitude": -0.146304,
		"google_business_url": "https://www.google.com/maps/place/ISSEY+MIYAKE+%2F+LONDON+33+BROOK/@51.5129867,-0.148488,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x5941d83dc51f81bc!8m2!3d51.5129867!4d-0.1462993?",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/33BROOK_2018jun08_27564a57-f6e0-4869-84da-4a9d2eb78f88.jpg?v=1676645686",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 2,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand3": "BAO BAO ISSEY MIYAKE",
		"brand4": "GOOD GOODS ISSEY MIYAKE",
		"brand5": "ISSEY MIYAKE PARFUMS",
		"brand6": "ISSEY MIYAKE WATCH",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ロンドン,伦敦,メイフェア,ボンドストリート,オックスフォードサーカス,Mayfair,BondStreet,OxfordCircus,梅费尔,离邦德街,牛津广场",
		"name": "ISSEY MIYAKE / LONDON 33 BROOK",
		"tel": "+44-20-7495-2306",
		"fax": "",
		"zipcode": "-",
		"address": "33 Brook Street, London, W1K 4HG",
		"description": "A flagship store that handles multiple brands located on Brook Street in the Mayfair district of London. Tokujin Yoshioka designed the minimalistic space spread over three floors and a 12-meter sharp-edged triangular steel hanger rail. A unique store with a contrast of historical architecture and contemporary design.",
		"store_hours": "<p>Business hours 10:00 - 18:00</p>\n<p>Thursday 10:00 - 19:00</p>\n<p>Sunday 12:00 - 18:00</p>",
		"description_note": ""
	},
	{
		"id": 927,
		"shop_code": 278,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "London",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 51.49917083,
		"longitude": -0.16319827,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 3,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "PLEATS PLEASE ISSEY MIYAKE",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ロンドン,伦敦",
		"name": "ISSEY MIYAKE HARRODS",
		"tel": "+44-20-7893-8381",
		"fax": "",
		"zipcode": "-",
		"address": "87-135 Brompton Rd, Knightsbridge, London SW1X 7XL",
		"description": "Find us on the 1st Floor, Women's Superbrands (International Designers), on the corner between Door 3 and Door 10. ",
		"store_hours": "<p>Business hours 10:00 - 21:00</p>\n<p>Sunday 11:30* - 18:00</p>\n<p>* Browsing only 11:30-12:00.</p>",
		"description_note": ""
	},
	{
		"id": 161,
		"shop_code": 92,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Paris, France",
		"has_members": false,
		"is_flagship": true,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 48.867975,
		"longitude": 2.322113,
		"google_business_url": "https://www.google.com/maps/place/ISSEY+MIYAKE+%2F+PARIS/@48.867842,2.3204497,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x47df57f4db4d519d!8m2!3d48.867842!4d2.3226384?",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/IMPARIS_2024feb26_01.jpg?v=1708913756",
		"img2": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/IMPARIS_2024feb26_02.jpg?v=1708913757",
		"img3": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/IMPARIS_2024feb26_03.jpg?v=1708913756",
		"img4": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/IMPARIS_2024feb26_04.jpg?v=1708913756",
		"img5": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/IMPARIS_2024feb26_05.jpg?v=1708913756",
		"img6": "NULL",
		"flagship_img": "",
		"position": 4,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "132 5. ISSEY MIYAKE",
		"brand3": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand4": "BAO BAO ISSEY MIYAKE",
		"brand5": "ISSEY MIYAKE PARFUMS",
		"brand6": "ISSEY MIYAKE WATCH",
		"brand7": "ISSEY MIYAKE EYES",
		"brand8": "ISSEY MIYAKE | MOLESKINE",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "パリ,巴黎,サントノーレ,サントノレ,リヴドロワ,コンコルド,マドレーヌ,FaubourgStHonoré,RiveDroite,Concorde,Madeleine,SaintHonore,StHonore,SaintHonoré,StHonoré,Saint-Honore,St-Honore,Saint-Honoré,St-Honoré,圣奥诺雷郊区,巴黎右岸,协和广场,马德莱娜",
		"name": "ISSEY MIYAKE / PARIS",
		"tel": "+33-1-48-87-01-86",
		"fax": "",
		"zipcode": "-",
		"address": "11 rue Royale, 75008 Paris",
		"description": "A new flagship store carrying multiple brands from ISSEY MIYAKE INC. in the heart of the Triangle d’or, located in the emblematic 8th arrondissement of Paris. The store space, designed by Tokujin Yoshioka, has a refined and modern aesthetic, respecting the history of the city while conveying the spirit of joy and wonder of the ISSEY MIYAKE brand. The orange aluminum walls shine as brightly as the sun, in a space that enhances the natural light, evoking a sense of energy for manufacturing and the future.",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 162,
		"shop_code": 93,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Paris, France",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 48.855507,
		"longitude": 2.326636,
		"google_business_url": "https://www.google.com/maps/place/PLEATS+PLEASE+ISSEY+MIYAKE+%2F+PARIS/@48.85549,2.3243293,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0xa8ecaa6637251ded!8m2!3d48.85549!4d2.326518?",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/PL_paris.jpg?v=1676645686",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 5,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "BAO BAO ISSEY MIYAKE",
		"brand3": "ISSEY MIYAKE PARFUMS",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "パリ,巴黎,リヴ・ゴーシュ,リヴゴーシュ,サンジェルマンデプレ,RiveGauche,StGermaindesPrès,StGermaindesPres,SaintGermaindesPres,SaintGermaindesPrés,St-GermaindesPrès,St-GermaindesPres,Saint-GermaindesPres,Saint-GermaindesPrés,巴黎左岸,圣日耳曼代普雷",
		"name": "PLEATS PLEASE ISSEY MIYAKE / PARIS",
		"tel": "+33-1-45-48-10-44",
		"fax": "",
		"zipcode": "-",
		"address": "201 Boulevard Saint Germain, 75007 Paris",
		"description": "A flagship store that handles multiple brands located on Boulevard Saint-Germain in Paris. It is a stylish and modern store where light shines through two large windows in a space based on white and Silver.",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1019,
		"shop_code": 317,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Paris, France",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 48.87413,
		"longitude": 2.32806,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 6,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "パリ,巴黎,paris",
		"name": "PLEATS PLEASE ISSEY MIYAKE PRINTEMPS",
		"tel": "+33-1-42-82-54-06",
		"fax": "",
		"zipcode": "-",
		"address": "64 Boulevard Haussmann 75009 Paris",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 163,
		"shop_code": 94,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Milan",
		"has_members": false,
		"is_flagship": true,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 45.46768,
		"longitude": 9.196662,
		"google_business_url": "https://www.google.com/maps/place/ISSEY+MIYAKE+%2F+MILAN/@45.467712,9.1944882,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0xa246393adda3e94c!8m2!3d45.467712!4d9.1966769?",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/MILAN_2022mar11_01_c31af5ca-2bad-4b07-982d-89626048ff60.jpg?v=1676645686",
		"img2": "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/IM_milan_02.jpg?v=1676645686",
		"img3": "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/IM_milan_03.jpg?v=1676645686",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 7,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "132 5. ISSEY MIYAKE",
		"brand3": "PLEATS PLEASE ISSEY MIYAKE",
		"brand4": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand5": "A-POC ABLE ISSEY MIYAKE",
		"brand6": "BAO BAO ISSEY MIYAKE",
		"brand7": "ISSEY MIYAKE PARFUMS",
		"brand8": "ISSEY MIYAKE WATCH",
		"brand9": "ISSEY MIYAKE EYES",
		"brand10": "ISSEY MIYAKE | MOLESKINE",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ミラノ,ミラン,米兰,モンテナポレオーネ,クアドリラテロデッラモダ,Montenapoleone,QuadrilaterodellaModa,蒙特拿破仑,时尚四边形",
		"name": "ISSEY MIYAKE / MILAN",
		"tel": "+39-02-781040",
		"fax": "",
		"zipcode": "-",
		"address": "Via Bagutta 12, 20121 Milano",
		"description": "The first ISSEY MIYAKE flagship store in Italy. Carrying multiple brands, the store is located on Via Bagutta next to Via Montenapoleone in Milan. Inside a historic mansion built in the 19th century are floating aluminum disks and sales floors in green, orange and blue, bringing history and the future together. Space design by Tokujin Yoshioka.",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 152,
		"shop_code": 83,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Zurich",
		"has_members": false,
		"is_flagship": true,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 47.370227,
		"longitude": 8.540698,
		"google_business_url": "https://www.google.com/maps/place/ISSEY+MIYAKE+%2F+ZURICH/@47.370224,8.5385053,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0xdb3e9dcd34f0dec7!8m2!3d47.370224!4d8.540694?",
		"prefecture_name": "",
		"img1": "https://isseymiyake-resources.s3.amazonaws.com/uploads/cloth/store/image1/152/ZURICH_2022mar11_01.jpg",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 8,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "132 5. ISSEY MIYAKE",
		"brand3": "PLEATS PLEASE ISSEY MIYAKE",
		"brand4": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand5": "BAO BAO ISSEY MIYAKE",
		"brand6": "ISSEY MIYAKE PARFUMS",
		"brand7": "ISSEY MIYAKE WATCH",
		"brand8": "ISSEY MIYAKE EYES",
		"brand9": "ISSEY MIYAKE | MOLESKINE",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ミュンスターホーフ,バーンホーフシュトラーセ,シュトルヒェンガッセ,パレードプラッツ,Munsterhof,Bahnhofstrasse,Storchengasse,Paradeplatz,大教堂庭院,班霍夫街,史主化街,帕拉德广场",
		"name": "ISSEY MIYAKE / ZURICH",
		"tel": "+41-44-211-53-23",
		"fax": "",
		"zipcode": "-",
		"address": "Münsterhof 12, 8001 Zürich",
		"description": "A flagship store carrying multiple brands from ISSEY MIYAKE INC. in Münsterhof, a town square in the historical center of Zürich. It is located in a historic building dating back to the 13th century, with a clear blue-based space designed by Tokujin Yoshioka. History meets the future, with the texture of the long-aged walls contrasting with aluminum that symbolizes the future.",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 160,
		"shop_code": 91,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "New York State",
		"has_members": false,
		"is_flagship": true,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 40.725272,
		"longitude": -74.000057,
		"google_business_url": "https://www.google.com/maps/place/PLEATS+PLEASE+ISSEY+MIYAKE+%2F+NEW+YORK/@40.725236,-74.0022407,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x22e99486a7d51f9!8m2!3d40.725236!4d-74.000052?",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/PL_NEWYORK_01.jpg?v=1733880967",
		"img2": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/PL_NEWYORK_02.jpg?v=1733880967",
		"img3": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/PL_NEWYORK_03.jpg?v=1733880967",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 10,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "ISSEY MIYAKE PARFUMS",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ニューヨーク, 纽约州,ソーホー,ウースター,マンハッタン,SoHo,Wooster,Manhattan,苏豪区,曼哈顿,伍斯特大街",
		"name": "PLEATS PLEASE ISSEY MIYAKE / NEW YORK",
		"tel": "+1-212-226-3600",
		"fax": "",
		"zipcode": "-",
		"address": "126 Prince St., New York, NY 10012",
		"description": "A flagship store carrying multiple brands from ISSEY MIYAKE INC. on Prince Street, New York. The store has a transparent design with windows letting in plenty of natural light, adding a sense of openness.",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1023,
		"shop_code": 321,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "New York State",
		"has_members": false,
		"is_flagship": true,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 40.7252927414881,
		"longitude": -73.9999963349457,
		"google_business_url": "https://www.google.com/maps/place/BAO+BAO+ISSEY+MIYAKE+%2F+NEW+YORK/@40.7252653,-74.0012905,156m/data=!3m1!1e3!4m10!1m2!2m1!1sBAO+BAO+ISSEY+MIYAKE+%2F+NEW+YORK!3m6!1s0x89c2598e870140cf:0xb9a55e86151bd7b1!8m2!3d40.7252653!4d-74.0000996!15sCh9CQU8gQkFPIElTU0VZIE1JWUFLRSAvIE5FVyBZT1JLIgOIAQFaHyIdYmFvIGJhbyBpc3NleSBtaXlha2UgbmV3IHlvcmuSAQ1oYW5kYmFnc19zaG9wqgF9Cg0vZy8xMXhrbWx0NHo4CgwvZy8xcTYyZ2NiazUQASoYIhRiYW8gYmFvIGlzc2V5IG1peWFrZSgAMh8QASIb4C0mElMiWcwcGGEoJJMOn_oSjPAcRQFu9MLfMiEQAiIdYmFvIGJhbyBpc3NleSBtaXlha2UgbmV3IHlvcmvgAQA!16s%2Fg%2F11xkmlt4z8?entry=ttu&g_ep=EgoyMDI1MDYxNi4wIKXMDSoASAFQAw%3D%3D",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/BB_NEWYORK2025jun12_01.jpg?v=1749521987",
		"img2": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/BB_NEWYORK2025jun12_02.jpg?v=1749544410",
		"img3": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/BB_NEWYORK2025jun12_03.jpg?v=1749544425",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 11,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ニューヨーク, 纽约州,ソーホー,マンハッタン,Soho,Manhattan,Prince Street,曼哈顿,苏豪区,王子街",
		"name": "BAO BAO ISSEY MIYAKE / NEW YORK",
		"tel": "+1-212-662-9060",
		"fax": "",
		"zipcode": "-",
		"address": "126 Prince St., New York, NY 10012",
		"description": "Located in the Soho neighbourhood of New York, this flagship store is a space where customers can experience the brand’s concept and design. In a space befitting for the creative and sophisticated neighbourhood, the main focus of the design concept is a warm light installed in the center of the ceiling in the store, which also functions as a presentation space for the brand.",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 3,
		"shop_code": 1,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": true,
		"is_flagship": true,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": true,
		"is_reservation": true,
		"latitude": 35.664642,
		"longitude": 139.713515,
		"google_business_url": "https://www.google.co.jp/maps/place/ISSEY+MIYAKE+%2F+AOYAMA/@35.6646577,139.7114664,17z/data=!3m1!4b1!4m5!3m4!1s0x60188b61749c0001:0x283e9e84406253b6!8m2!3d35.6646577!4d139.7136551?",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/IM_AOYAMA_2020nov26_01_345d0b6e-06a2-448d-8a1a-12f4624292e4.jpg?v=1676645686",
		"img2": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_IM__002_1020.jpg?v=1679149795",
		"img3": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_IM__003_1020.jpg?v=1679149794",
		"img4": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_IM__004_1020.jpg?v=1679149795",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 12,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "ISSEY MIYAKE PARFUMS",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,原宿,明治神宮前,表参道,御幸通り,みゆき通り,harajuku,meijijingumae,omotesando,miyukidori,miyukistreet,表參道",
		"name": "ISSEY MIYAKE / AOYAMA",
		"tel": "03-3423-1408",
		"fax": "",
		"zipcode": "107-0062",
		"address": "3-18-11 Minamiaoyama, Minato-ku, Tokyo",
		"description": "Based on the concept of being a store that is always filled with new discoveries and creations, this FLAGSHIP STORES offers a variety of proposals born from ISSEY MIYAKE 's creations. Space design by Tokujin Yoshioka.<br />",
		"store_hours": "Business hours 11:00 ー 20:00",
		"description_note": ""
	},
	{
		"id": 898,
		"shop_code": 273,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": true,
		"is_flagship": true,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": true,
		"is_reservation": false,
		"latitude": 35.66460951,
		"longitude": 139.7136726,
		"google_business_url": "https://www.google.co.jp/maps/place/IM+MEN+%2F+AOYAMA/@35.6646444,139.711441,17z/data=!3m1!4b1!4m5!3m4!1s0x60188b3f31bf96a3:0xed9b9900ba8cd4c6!8m2!3d35.6646444!4d139.7136297?",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_LA__001_1020.jpg?v=1679149823",
		"img2": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_LA__002_1020.jpg?v=1679149823",
		"img3": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_LA__003_1020.jpg?v=1679149823",
		"img4": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_LA__004_1020.jpg?v=1679149823",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 13,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "IM MEN",
		"brand2": "ISSEY MIYAKE WATCH",
		"brand3": "ISSEY MIYAKE EYES",
		"brand4": "ISSEY MIYAKE FOOT",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,原宿,明治神宮前,表参道,御幸通り,みゆき通り,harajuku,meijijingumae,omotesando,miyukidori,miyukistreet,表參道,書籍",
		"name": "IM MEN / AOYAMA",
		"tel": "03-3423-1407",
		"fax": "",
		"zipcode": "107-0062",
		"address": "3-18-11 Minamiaoyama, Minato-ku, Tokyo",
		"description": "This is the first standalone store of IM MEN, a brand that proposes new men's daily wear that pursues practicality and simple functional beauty as a product that blends into modern life scenes. It is a special store where the space design by Mr. Shiro Kuramata in 1987 still exists.",
		"store_hours": "Business hours 11:00 ー 20:00",
		"description_note": ""
	},
	{
		"id": 44,
		"shop_code": 19,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": true,
		"is_flagship": true,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": true,
		"is_reservation": true,
		"latitude": 35.664481,
		"longitude": 139.713819,
		"google_business_url": "https://www.google.com/maps/place/PLEATS+PLEASE+ISSEY+MIYAKE+%2F+AOYAMA/@35.664512,139.7116713,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0xa15e7b9dbe3fa461!8m2!3d35.664512!4d139.71386",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/PL_AOYAMA_2025oct17_01.jpg?v=1760589799",
		"img2": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/PL_AOYAMA_2025oct17_02.jpg?v=1760589799",
		"img3": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/PL_AOYAMA_2025oct17_03.jpg?v=1760589799",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 16,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "ISSEY MIYAKE PARFUMS",
		"brand3": "ISSEY MIYAKE WATCH",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,原宿,明治神宮前,表参道,御幸通り,みゆき通り,harajuku,meijijingumae,omotesando,miyukidori,miyukistreet,表參道,書籍,aoyama,AOYAMA,青山",
		"name": "PLEATS PLEASE ISSEY MIYAKE / AOYAMA",
		"tel": "03-5772-7750",
		"fax": "",
		"zipcode": "107-0062",
		"address": "5-3-8 Minamiaoyama, Minato-ku, Tokyo",
		"description": "A flagship store spans three floors with the full lineup from PLEATS PLEASE ISSEY MIYAKE. A rainbow of products sandwiched between pleating papers boldly adorn the first-floor walls, telling the story of garments crafted using our signature pleating technique. Structured hanger racks, specially designed to make the clothing appear to be floating, express the lightness of PLEATS PLEASE products. Inside transparent glass cases, PLEATS PLEASE fabric is arranged in a playful rolled display. The space was designed by Tokujin Yoshioka.",
		"store_hours": "Business hours 11:00 ー 20:00",
		"description_note": ""
	},
	{
		"id": 45,
		"shop_code": 20,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": true,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": true,
		"is_reservation": true,
		"latitude": 35.665503,
		"longitude": 139.730053,
		"google_business_url": "https://www.google.com/maps/place/PLEATS+PLEASE+ISSEY+MIYAKE+%2F+ROPPONGI/@35.665505,139.7278643,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0xd0e2deeb088e6fbf!8m2!3d35.665505!4d139.730053?",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/PL_ROPPONGI_01.jpg?v=1733903972",
		"img2": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/PL_ROPPONGI_02.jpg?v=1733903972",
		"img3": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/PL_ROPPONGI_03.jpg?v=1733903972",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 15,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "ISSEY MIYAKE PARFUMS",
		"brand3": "ISSEY MIYAKE WATCH",
		"brand4": "ISSEY MIYAKE EYES",
		"brand5": "ISSEY MIYAKE | MOLESKINE",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,六本木,乃木坂,roppongi,nogizaka,nogisaka,書籍",
		"name": "PLEATS PLEASE ISSEY MIYAKE / ROPPONGI",
		"tel": "03-5413-7257",
		"fax": "",
		"zipcode": "107-0052",
		"address": "2F Galleria Tokyo Midtown, 9-7-3 Akasaka, Minato-ku, Tokyo",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 783,
		"shop_code": 247,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": true,
		"is_flagship": true,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": true,
		"is_reservation": true,
		"latitude": 35.664837,
		"longitude": 139.713374,
		"google_business_url": "https://www.google.com/maps/place/HOMME+PLISS%C3%89+ISSEY+MIYAKE+%2F+AOYAMA/@35.6647708,139.7111347,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x73acc5cb40c24027!8m2!3d35.6647708!4d139.7133234?",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_HP__001_1020.jpg?v=1679149767",
		"img2": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_HP__002_1020.jpg?v=1679149767",
		"img3": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_HP__003_1020.jpg?v=1679149767",
		"img4": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_HP__004_1020.jpg?v=1679149767",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 16,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand2": "ISSEY MIYAKE WATCH",
		"brand3": "ISSEY MIYAKE EYES",
		"brand4": "ISSEY MIYAKE | MOLESKINE",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "原宿,明治神宮前,表参道,御幸通り,みゆき通り,harajuku,meijijingumae,omotesando,miyukidori,miyukistreet,表參道",
		"name": "HOMME PLISSÉ ISSEY MIYAKE / AOYAMA",
		"tel": "03-5411-5007",
		"fax": "",
		"zipcode": "107-0062",
		"address": "3-18-14 Minamiaoyama, Minato-ku, Tokyo",
		"description": "This flagship store offers the full lineup of HOMME PLISSÉ ISSEY MIYAKE. In the spacious shop equipped with a pleating machine, we will show you the technique of pleating clothes. Tokujin Yoshioka designed the space.",
		"store_hours": "Business hours 11:00 ー 20:00",
		"description_note": ""
	},
	{
		"id": 83,
		"shop_code": 42,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": true,
		"is_flagship": true,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": true,
		"is_reservation": true,
		"latitude": 35.648698,
		"longitude": 139.700846,
		"google_business_url": "https://www.google.com/maps/place/HOMME+PLISS%C3%89+ISSEY+MIYAKE+%2F+DAIKANYAMA/@35.6487555,139.6987111,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x12421977f7dcdabd!8m2!3d35.6487555!4d139.7008998?",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_HP__001_1020_5dfc1c83-d1c3-45c9-b2bb-3933961aac49.jpg?v=1679149786",
		"img2": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_HP__002_1020_7e71371b-30f6-4ff6-8164-758123eced9c.jpg?v=1679149786",
		"img3": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_HP__003_1020_34b97dbe-ad22-4d54-b44e-a0e414910b38.jpg?v=1679149786",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 17,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand2": "ISSEY MIYAKE WATCH",
		"brand3": "ISSEY MIYAKE FOOT",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,shibuya,涩谷,代官山,daikanyama,書籍",
		"name": "HOMME PLISSÉ ISSEY MIYAKE / DAIKANYAMA",
		"tel": "03-6277-5085",
		"fax": "",
		"zipcode": "150-0033",
		"address": "T2 Bldg., 19-8 Sarugakucho, Shibuya-ku, Tokyo",
		"description": "HOMME PLISSÉ ISSEY MIYAKE 's first FLAGSHIP STORES in Tokyo. Naoto Fukasawa worked on the spatial design of the concept of a trapezoidal concrete building with two floors and thin, wide beams that make clothes look like they are floating.",
		"store_hours": "Business hours 11:00 ー 20:00",
		"description_note": ""
	},
	{
		"id": 1031,
		"shop_code": 339,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": true,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": true,
		"is_reservation": true,
		"latitude": 35.665503,
		"longitude": 139.730053,
		"google_business_url": "https://www.google.com/maps/place/HOMME+PLISS%C3%89+ISSEY+MIYAKE+%2F+ROPPONGI/@35.6659802,139.7260038,754m/data=!3m3!1e3!4b1!5s0x60188b78945432c1:0x7acbd95657b55136!4m6!3m5!1s0x60188b00572cbfbb:0xe24fecd956b62bdb!8m2!3d35.6659803!4d139.7308747!16s%2Fg%2F11mlbyc277?hl=ja&authuser=0&entry=ttu&g_ep=EgoyMDI1MTExMS4wIKXMDSoASAFQAw%3D%3D",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP_ROPPONGI_2025nov14_01.jpg?v=1763094735",
		"img2": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP_ROPPONGI_2025nov14_02.jpg?v=1763094735",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 18,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand2": "ISSEY MIYAKE FOOT",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,六本木,乃木坂,roppongi,nogizaka,nogisaka",
		"name": "HOMME PLISSÉ ISSEY MIYAKE / ROPPONGI",
		"tel": "03-6447-5615",
		"fax": "",
		"zipcode": "107-0052",
		"address": "2F Galleria Tokyo Midtown, 9-7-3 Akasaka, Minato-ku, Tokyo",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 899,
		"shop_code": 274,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": true,
		"is_flagship": true,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": true,
		"is_reservation": true,
		"latitude": 35.66283821,
		"longitude": 139.7159284,
		"google_business_url": "https://www.google.com/maps/place/A-POC+ABLE+ISSEY+MIYAKE+%2F+AOYAMA/@35.6628077,139.713729,17z/data=!3m1!4b1!4m5!3m4!1s0x60188beb2de4c497:0x76d517792c8bfc4c!8m2!3d35.6628077!4d139.7159177",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_AT_AOYAMA_001_1168.jpg?v=1683699967",
		"img2": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_AT_AOYAMA_002_1168.jpg?v=1683699976",
		"img3": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_AT_AOYAMA_003_1168.jpg?v=1683699986",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 19,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "A-POC ABLE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,原宿,明治神宮前,表参道,御幸通り,みゆき通り,harajuku,meijijingumae,omotesando,miyukidori,miyukistreet,表參道",
		"name": "A-POC ABLE ISSEY MIYAKE / AOYAMA",
		"tel": "03-3499-6476",
		"fax": "",
		"zipcode": "107-0062",
		"address": "FROM-1st, 5-3-10 Minamiaoyama, Minato-ku, Tokyo",
		"description": "The flagship store of A-POC ABLE ISSEY MIYAKE, which sparks communication between creators and wearers. This is a space where people can experience the latest craftsmanship of the brand that continues and develops A-POC, which offers a form of design in which the wearers partake.",
		"store_hours": "Business hours 11:00 ー 20:00",
		"description_note": ""
	},
	{
		"id": 950,
		"shop_code": 284,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Kyoto",
		"has_members": true,
		"is_flagship": true,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": true,
		"is_reservation": true,
		"latitude": 35.009162,
		"longitude": 135.764894,
		"google_business_url": "https://www.google.com/maps/place/A-POC+ABLE+ISSEY+MIYAKE+%2F+KYOTO/@35.0091988,135.7627682,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x3e0b42367e186c86!8m2!3d35.0091988!4d135.7649569",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/AT_KYOTO_2022mar04_02_883b54c9-db66-4046-9bbb-7cefd26e4f34.jpg?v=1676645686",
		"img2": "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/AT_KYOTO_2022mar04_01.jpg?v=1676645686",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 20,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "A-POC ABLE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "kyoto,烏丸御池,karasumaoike,乌丸御池,三条,sanjyo",
		"name": "A-POC ABLE ISSEY MIYAKE / KYOTO",
		"tel": "075-251-1288",
		"fax": "",
		"zipcode": "604-8084",
		"address": "106 Fukunagacho, Sanjo-agaru, Tominokoji-dori, Nakagyo-ku, Kyoto-shi, Kyoto",
		"description": "This space designed by Tokujin Yoshioka combines a refined Kyoto machiya townhouse with a modern look using aluminum. This street-level store transmits the vision of A-POC ABLE ISSEY MIYAKE, which introduces new ways of thinking into traditional techniques, realizes ideas that reflect modern times, and passes this on to the future.",
		"store_hours": "Business hours 11:00 ー 20:00",
		"description_note": ""
	},
	{
		"id": 110,
		"shop_code": 52,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": true,
		"is_flagship": true,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": true,
		"is_reservation": false,
		"latitude": 35.663407,
		"longitude": 139.715459,
		"google_business_url": "https://www.google.com/maps/place/me+ISSEY+MIYAKE+%2F+AOYAMA/@35.6634239,139.7132656,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x47c1a76e52e59d03!8m2!3d35.6634239!4d139.7154543?",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_MI__001_1020_951d5942-a84e-440b-80b4-04e9c101d671.jpg?v=1744101652",
		"img2": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_MI__002_1020_fc60e14f-b52d-418a-a9c4-75db9617f321.jpg?v=1744103124",
		"img3": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_MI__003_1020_a2b4ecf0-20aa-4f4d-bbfe-843a084a13ce.jpg?v=1744101652",
		"img4": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_MI__004_1020.jpg?v=1744101652",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 21,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,原宿,明治神宮前,表参道,御幸通り,みゆき通り,harajuku,meijijingumae,omotesando,miyukidori,miyukistreet,表參道,書籍",
		"name": "me ISSEY MIYAKE / AOYAMA",
		"tel": "03-3479-3133",
		"fax": "",
		"zipcode": "107-0062",
		"address": "4-21-24 Minamiaoyama, Minato-ku, Tokyo",
		"description": "A flagship store with the full lineup from me ISSEY MIYAKE. Designed by Naoto Fukasawa, the cornerless walls create an atmosphere where you are surrounded by light and air.",
		"store_hours": "Business hours 11:00 ー 20:00",
		"description_note": ""
	},
	{
		"id": 91,
		"shop_code": 48,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": true,
		"is_flagship": true,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": true,
		"is_reservation": false,
		"latitude": 35.663734,
		"longitude": 139.714925,
		"google_business_url": "https://www.google.com/maps/place/HaaT+%2F+AOYAMA/@35.66372,139.71278,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x9e3b293cd48f9178!8m2!3d35.66372!4d139.7149687?",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_HaaT__001_1020.jpg?v=1679149733",
		"img2": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_HaaT__002_1020.jpg?v=1679149733",
		"img3": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_HaaT__003_1020.jpg?v=1679149733",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 22,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HaaT",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,原宿,明治神宮前,表参道,御幸通り,みゆき通り,harajuku,meijijingumae,omotesando,miyukidori,miyukistreet,表參道",
		"name": "HaaT / AOYAMA",
		"tel": "03-5785-0400",
		"fax": "",
		"zipcode": "107-0062",
		"address": "4-21-29 Minamiaoyama, Minato-ku, Tokyo",
		"description": "HaaT’s flagship store, combining a range of techniques, materials and esthetics that transcends borders. Designed by Tokujin Yoshioka, the space brings together organic beauty and materials made through industrial processes, creating an alluring contrast.",
		"store_hours": "Business hours 11:00 ー 20:00",
		"description_note": ""
	},
	{
		"id": 1032,
		"shop_code": 340,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Kyoto",
		"has_members": true,
		"is_flagship": true,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": true,
		"is_reservation": false,
		"latitude": 35.010177,
		"longitude": 135.764455,
		"google_business_url": "https://www.google.com/maps/place/HaaT+%2F+KYOTO/@35.0099636,135.7618418,631m/data=!3m2!1e3!4b1!4m6!3m5!1s0x600109a7ef1dc71d:0xc8c9383df18ee2c4!8m2!3d35.0099636!4d135.7644167!16s%2Fg%2F11yndbvgz3?entry=ttu&g_ep=EgoyMDI1MTExNy4wIKXMDSoASAFQAw%3D%3D",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HA_KYOTO_2025nov21_01.jpg?v=1763692667",
		"img2": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HA_KYOTO_2025nov21_02.jpg?v=1763692667",
		"img3": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HA_KYOTO_2025nov21_03.jpg?v=1763692667",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 23,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HaaT",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "kyoto,京都,姉小路通,三条,Anekouji,sanjyo",
		"name": "HaaT / KYOTO",
		"tel": "075-748-1153",
		"fax": "",
		"zipcode": "604-8102",
		"address": "569 Kikuyacho, Yanaginobanba Higashi-iru, Aneyakoji-dori, Nakagyo-ku, Kyoto",
		"description": "In a traditional Kyoto machiya townhouse, aluminum infused with delicate shades of cherry blossom pink brings a refined radiance to the space. Designed by Tokujin Yoshioka, this store is a place where history and the future coexist in harmony. While preserving the wisdom and spirit of daily life passed down through generations, this flagship store showcases to the world the distinctive materials and techniques that define HaaT.",
		"store_hours": "Business hours 11:00 ー 20:00",
		"description_note": ""
	},
	{
		"id": 683,
		"shop_code": 224,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": true,
		"is_flagship": true,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": true,
		"is_reservation": true,
		"latitude": 35.648758,
		"longitude": 139.7009,
		"google_business_url": "https://www.google.com/maps/place/GOOD+GOODS+ISSEY+MIYAKE+%2F+DAIKANYAMA/@35.6487457,139.6987201,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0xb675864f8adae263!8m2!3d35.6487457!4d139.7009088?",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_GDGDS_DKYM_01_1020.jpg?v=1715230308",
		"img2": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_GDGDS_DKYM_02_1020.jpg?v=1715230309",
		"img3": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_GDGDS_DKYM_03_1020.jpg?v=1715230308",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 24,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "GOOD GOODS ISSEY MIYAKE",
		"brand2": "ISSEY MIYAKE WATCH",
		"brand3": "ISSEY MIYAKE | MOLESKINE",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,代官山,daikanyama",
		"name": "GOOD GOODS ISSEY MIYAKE / DAIKANYAMA",
		"tel": "03-5457-3017",
		"fax": "",
		"zipcode": "150-0033",
		"address": "T2 Bldg., 19-8 Sarugakucho, Shibuya-ku, Tokyo",
		"description": "GOOD GOODS ISSEY MIYAKE develops accessories to explore what it is that makes a product “good”. Located in Daikanyama district in Tokyo, the GOOD GOODS ISSEY MIYAKE’s flagship store designed by Tokujin Yoshioka is futuristic and expressive, featuring walls with dynamic diagonal slits. The store features a wide range of “good things”, products that elevate modern lifestyles, adding excitement and fun to everyday life.",
		"store_hours": "Business hours 11:00 ー 20:00",
		"description_note": ""
	},
	{
		"id": 85,
		"shop_code": 44,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": true,
		"is_flagship": true,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": true,
		"is_reservation": true,
		"latitude": 35.663031,
		"longitude": 139.715711,
		"google_business_url": "https://www.google.com/maps/place/REALITY+LAB.+ISSEY+MIYAKE/@35.6628077,139.713729,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x586c947cc8f8c4eb!8m2!3d35.6628077!4d139.7159177?",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_RLIM_001_1020.jpg?v=1679149881",
		"img2": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_RLIM_002_1020.jpg?v=1679149881",
		"img3": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_RLIM_003_1020.jpg?v=1679149881",
		"img4": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_RLIM_004_1020.jpg?v=1679149881",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 25,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "132 5. ISSEY MIYAKE",
		"brand2": "BAO BAO ISSEY MIYAKE",
		"brand3": "ISSEY MIYAKE PARFUMS",
		"brand4": "ISSEY MIYAKE WATCH",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,原宿,明治神宮前,表参道,御幸通り,みゆき通り,harajuku,meijijingumae,omotesando,miyukidori,miyukistreet,表參道",
		"name": "REALITY LAB. ISSEY MIYAKE",
		"tel": "03-3499-6496",
		"fax": "",
		"zipcode": "107-0062",
		"address": "FROM-1st, 5-3-10 Minamiaoyama, Minato-ku, Tokyo",
		"description": "REALITY LAB. ISSEY MIYAKE is a store with a three-tiered structure in the From First Building. This store, which handles multiple brands, is transmitting innovative manufacturing. Space design by Tokujin Yoshioka.",
		"store_hours": "Business hours 11:00 ー 20:00",
		"description_note": ""
	},
	{
		"id": 971,
		"shop_code": 292,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": true,
		"is_flagship": true,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": true,
		"is_reservation": true,
		"latitude": 35.6723309,
		"longitude": 139.7652733,
		"google_business_url": "https://www.google.com/maps/place/ISSEY+MIYAKE+GINZA+%2F+442/@35.6723309,139.7652733,17z/data=!3m2!4b1!5s0x60188be42d1e5777:0x159d2c8d619d9daa!4m6!3m5!1s0x60188bb20e225cd9:0xadc13e81bb6c4d5b!8m2!3d35.6723309!4d139.7652733!16s%2Fg%2F11k9b7sl10?",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/GINZA442_2023feb03_01_47f75eac-36a2-4710-943f-12368122548e.jpg?v=1676647206",
		"img2": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_GINZA442_002_1020.jpg?v=1679149717",
		"img3": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_GINZA442_003_1020.jpg?v=1679149717",
		"img4": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_GINZA442_004_1020.jpg?v=1679149717",
		"img5": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_GINZA442_005_1020.jpg?v=1679149717",
		"img6": "NULL",
		"flagship_img": "",
		"position": 26,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "IM MEN",
		"brand3": "PLEATS PLEASE ISSEY MIYAKE",
		"brand4": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand5": "A-POC ABLE ISSEY MIYAKE",
		"brand6": "BAO BAO ISSEY MIYAKE",
		"brand7": "GOOD GOODS ISSEY MIYAKE",
		"brand8": "ISSEY MIYAKE PARFUMS",
		"brand9": "ISSEY MIYAKE WATCH",
		"brand10": "ISSEY MIYAKE EYES",
		"brand11": "ISSEY MIYAKE | MOLESKINE",
		"brand12": "ISSEY MIYAKE FOOT",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,有楽町,ガス灯通り,日比谷,yurakucho,gasutodori,hibiya,有乐町,汽油燈通,書籍",
		"name": "ISSEY MIYAKE GINZA / 442",
		"tel": "03-6263-0705",
		"fax": "",
		"zipcode": "104-0061",
		"address": "4-4-2 Ginza, Chuo-ku, Tokyo",
		"description": "ISSEY MIYAKE brands are gathered over four floors. You can see how Tokujin Yoshioka works to create a better relationship between clothes and people in a simple space with an aluminum wall. A store that incorporates elegance, playfulness, and challenges for the future, befitting the town of Ginza.",
		"store_hours": "Business hours 11:00 ー 20:00",
		"description_note": ""
	},
	{
		"id": 46,
		"shop_code": 21,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": true,
		"is_flagship": true,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": true,
		"is_reservation": true,
		"latitude": 35.672043,
		"longitude": 139.7650456,
		"google_business_url": "https://www.google.com/maps/place/ISSEY+MIYAKE+GINZA+%2F+445/@35.672043,139.7628569,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x2bdb3e5ea6172f80!8m2!3d35.672043!4d139.7650456?",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/GINZA445_2023feb03_01.jpg?v=1676647206",
		"img2": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_GINZA445_002_1020.jpg?v=1679149725",
		"img3": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_GINZA445_003_1020.jpg?v=1679149724",
		"img4": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_GINZA445_004_1020.jpg?v=1679149725",
		"img5": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_GINZA445_005_1020.jpg?v=1679149724",
		"img6": "NULL",
		"flagship_img": "",
		"position": 27,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "132 5. ISSEY MIYAKE",
		"brand2": "me ISSEY MIYAKE",
		"brand3": "HaaT",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,ginza,银座,有楽町,ガス灯通り,日比谷,yurakucho,gasutodori,hibiya,有乐町,汽油燈通",
		"name": "ISSEY MIYAKE GINZA / 445",
		"tel": "03-3566-5225",
		"fax": "",
		"zipcode": "104-0061",
		"address": "4-4-5 Ginza, Chuo-ku, Tokyo",
		"description": "Located on Gaslight Street in Ginza 4-chome, Tokyo, this store carries multiple brands. It is a calm space that modestly expresses the “goods” and “play” of adults. The minimalist space design based on neutral white is by Taku Satoh. The exhibition space “CUBE” on the 1st floor will hold exhibitions and events related to the activities of ISSEY MIYAKE, as well as design, arts and crafts that enrich people's lives.",
		"store_hours": "Business hours 11:00 ー 20:00",
		"description_note": ""
	},
	{
		"id": 84,
		"shop_code": 43,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": true,
		"is_flagship": true,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": true,
		"is_reservation": true,
		"latitude": 35.681635,
		"longitude": 139.763199,
		"google_business_url": "https://www.google.com/maps/place/ISSEY+MIYAKE+MARUNOUCHI/@35.6816046,139.7610106,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x6a46572ea02e1064!8m2!3d35.6816046!4d139.7631993?",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/MARUNOUCHI_2019apr10_88d57f59-bc88-42f4-bbe5-13669cbbdce0.jpg?v=1676645687",
		"img2": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_MARUNOUCHI_002_1020.jpg?v=1679149830",
		"img3": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_MARUNOUCHI_003_1020.jpg?v=1679149830",
		"img4": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_MARUNOUCHI_004_1020.jpg?v=1679149830",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 28,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "132 5. ISSEY MIYAKE",
		"brand2": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand3": "A-POC ABLE ISSEY MIYAKE",
		"brand4": "BAO BAO ISSEY MIYAKE",
		"brand5": "ISSEY MIYAKE PARFUMS",
		"brand6": "ISSEY MIYAKE WATCH",
		"brand7": "ISSEY MIYAKE EYES",
		"brand8": "ISSEY MIYAKE | MOLESKINE",
		"brand9": "ISSEY MIYAKE FOOT",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,二重橋前,行幸通り,丸の内仲通り,nijyubashimae,gyokodori,marunouchinakadori,二重桥前,行幸通,丸之内仲通,書籍",
		"name": "ISSEY MIYAKE MARUNOUCHI",
		"tel": "03-5221-9900",
		"fax": "",
		"zipcode": "100-0005",
		"address": "Yusen Bldg., 2-3-2 Marunouchi, Chiyoda-ku, Tokyo",
		"description": "A store that handles multiple brands located in Marunouchi, the gateway to Tokyo. You can experience Issey Miyake's universal craftsmanship, \"creating something that has never existed before, for the comfort of people's daily lives.\" The red-based space was designed by Tokujin Yoshioka.",
		"store_hours": "Business hours 11:00 ー 20:00",
		"description_note": ""
	},
	{
		"id": 8,
		"shop_code": 5,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.69175741,
		"longitude": 139.704789,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/IM_SHINUJUKU_22NOV23_016.jpg?v=1700645403",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 29,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "PLEATS PLEASE ISSEY MIYAKE",
		"brand3": "ISSEY MIYAKE FOOT",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,新宿,shinjyuku,新宿三丁目,shinjukusanchome,伊勢丹,isetan",
		"name": "ISSEY MIYAKE SHINJUKU",
		"tel": "03-3350-6092",
		"fax": "",
		"zipcode": "160-0022",
		"address": "2F Main Bldg., 3-14-1 Shinjuku, Shinjuku-ku, Tokyo",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 794,
		"shop_code": 254,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": true,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": true,
		"is_reservation": true,
		"latitude": 35.662216,
		"longitude": 139.698891,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/IMSHIBUYA_2022nov04_01.jpg?v=1677819153",
		"img2": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_SHIBUYA_002_1020.jpg?v=1679149898",
		"img3": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_SHIBUYA_003_1020.jpg?v=1679149898",
		"img4": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_SHIBUYA_004_1020.jpg?v=1679149898",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 30,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "IM MEN",
		"brand2": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand3": "A-POC ABLE ISSEY MIYAKE",
		"brand4": "BAO BAO ISSEY MIYAKE",
		"brand5": "GOOD GOODS ISSEY MIYAKE",
		"brand6": "ISSEY MIYAKE PARFUMS",
		"brand7": "ISSEY MIYAKE WATCH",
		"brand8": "ISSEY MIYAKE EYES",
		"brand9": "ISSEY MIYAKE | MOLESKINE",
		"brand10": "ISSEY MIYAKE FOOT",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,パルコ,公園通り,koendori,公园通,shibuya",
		"name": "ISSEY MIYAKE SHIBUYA",
		"tel": "03-5422-3540",
		"fax": "",
		"zipcode": "150-8377",
		"address": "2F, Shibuya PARCO, 15-1 Udagawa-cho, Shibuya-ku, Tokyo",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 562,
		"shop_code": 204,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Kyoto",
		"has_members": true,
		"is_flagship": true,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": true,
		"is_reservation": true,
		"latitude": 35.007992,
		"longitude": 135.7639,
		"google_business_url": "https://www.google.com/maps/place/ISSEY+MIYAKE+KYOTO/@35.007992,135.7617113,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0xaaa323ed297152d!8m2!3d35.007992!4d135.7639?hl",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_IMKYOTO_001_1020.jpg?v=1679149815",
		"img2": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_IMKYOTO_002_1020.jpg?v=1679149815",
		"img3": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_IMKYOTO_003_1020.jpg?v=1679149815",
		"img4": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_IMKYOTO_004_1020.jpg?v=1679149815",
		"img5": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_IMKYOTO_005_1020.jpg?v=1679149815",
		"img6": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_IMKYOTO_006_1020.jpg?v=1679149815",
		"flagship_img": "",
		"position": 31,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "IM MEN",
		"brand3": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand4": "BAO BAO ISSEY MIYAKE",
		"brand5": "GOOD GOODS ISSEY MIYAKE",
		"brand6": "ISSEY MIYAKE PARFUMS",
		"brand7": "ISSEY MIYAKE WATCH",
		"brand8": "ISSEY MIYAKE EYES",
		"brand9": "ISSEY MIYAKE | MOLESKINE",
		"brand10": "ISSEY MIYAKE FOOT",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "ISSEY MIYAKE KYOTO | KURA",
		"keyword": "kyoto,烏丸御池,三条,柳馬場六角上ル,町家,karasumaoike,sanjyo,sanjyosagaru,rokkakunoboru,machiya,乌丸御池,書籍",
		"name": "ISSEY MIYAKE KYOTO",
		"tel": "075-254-7540",
		"fax": "",
		"zipcode": "604-8112",
		"address": "89 Tsuchiyacho, Sanjo-sagaru, Yanaginobanba-dori, Nakagyo-ku, Kyoto-shi, Kyoto",
		"description": "Naoto Fukasawa designed a space that harmonizes the historic townhouse with Issey Miyake's craftsmanship. The store has a calm appearance with a base color of ink, fusing tradition and innovation. The KURA gallery at the back of the main house will showcase a wide variety of endeavors.",
		"store_hours": "Business hours 11:00 ー 20:00",
		"description_note": ""
	},
	{
		"id": 67,
		"shop_code": 33,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Osaka",
		"has_members": true,
		"is_flagship": true,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": true,
		"is_reservation": true,
		"latitude": 34.676656,
		"longitude": 135.498835,
		"google_business_url": "https://www.google.com/maps/place/ISSEY+MIYAKE+SEMBA/@34.676656,135.4966463,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x1ea7dfed01e16959!8m2!3d34.676656!4d135.498835?",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/IMS_2019aug30_01_abc259d6-820e-4cc7-a50a-1c513a078084.jpg?v=1676645686",
		"img2": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_SEMBA_002_1020.jpg?v=1679149889",
		"img3": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_SEMBA_003_1020.jpg?v=1679149889",
		"img4": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_SEMBA_004_1020.jpg?v=1679149890",
		"img5": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_SEMBA_005_1020.jpg?v=1679149890",
		"img6": "NULL",
		"flagship_img": "",
		"position": 32,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "IM MEN",
		"brand3": "132 5. ISSEY MIYAKE",
		"brand4": "PLEATS PLEASE ISSEY MIYAKE",
		"brand5": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand6": "A-POC ABLE ISSEY MIYAKE",
		"brand7": "BAO BAO ISSEY MIYAKE",
		"brand8": "me ISSEY MIYAKE",
		"brand9": "HaaT",
		"brand10": "GOOD GOODS ISSEY MIYAKE",
		"brand11": "ISSEY MIYAKE PARFUMS",
		"brand12": "ISSEY MIYAKE WATCH",
		"brand13": "ISSEY MIYAKE EYES",
		"brand14": "ISSEY MIYAKE | MOLESKINE",
		"brand15": "ISSEY MIYAKE FOOT",
		"gallery": "",
		"keyword": "osaka,心斎橋,四ツ橋,ミナミ,みなみ,御堂筋,shinsaibashi,yotsubashi,minami,midousuji,心斋桥,四桥,南",
		"name": "ISSEY MIYAKE SEMBA",
		"tel": "06-6251-8887",
		"fax": "",
		"zipcode": "542-0081",
		"address": "4-11-28 Minamisemba, Chuo-ku, Osaka-shi, Osaka",
		"description": "The only store in Osaka that handles multiple brands. The store is based on the concept of a “fountain of creation,” filled with humorous ideas related to “water” and the unique craftsmanship of each brand. In the underground creation space, various experiments such as exhibitions and events are held.",
		"store_hours": "Business hours 11:00 ー 20:00",
		"description_note": ""
	},
	{
		"id": 20,
		"shop_code": 12,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Hyogo",
		"has_members": true,
		"is_flagship": true,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": true,
		"is_reservation": true,
		"latitude": 34.687167,
		"longitude": 135.190519,
		"google_business_url": "https://www.google.com/maps/place/ISSEY+MIYAKE+KOBE/@34.687166,135.1883293,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x61f22b32cc444b4e!8m2!3d34.687166!4d135.190518?",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_IMKOBE_001_1020.jpg?v=1679149805",
		"img2": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_IMKOBE_002_1020.jpg?v=1679149805",
		"img3": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_IMKOBE_003_1020.jpg?v=1679149805",
		"img4": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_IMKOBE_004_1020.jpg?v=1679149805",
		"img5": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_IMKOBE_005_1020.jpg?v=1679149805",
		"img6": "NULL",
		"flagship_img": "",
		"position": 33,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "132 5. ISSEY MIYAKE",
		"brand3": "PLEATS PLEASE ISSEY MIYAKE",
		"brand4": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand5": "GOOD GOODS ISSEY MIYAKE",
		"brand6": "ISSEY MIYAKE PARFUMS",
		"brand7": "ISSEY MIYAKE WATCH",
		"brand8": "ISSEY MIYAKE EYES",
		"brand9": "ISSEY MIYAKE | MOLESKINE",
		"brand10": "ISSEY MIYAKE FOOT",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "兵库,hyogo,大丸,元町,三宮,daimaru,motomachi,sannomiya",
		"name": "ISSEY MIYAKE KOBE",
		"tel": "078-392-2223",
		"fax": "",
		"zipcode": "650-0039",
		"address": "NTT Nishinihon Shinkobe Bldg., 1 Maemachi, Chuo-ku, Kobe-shi, Hyogo",
		"description": "It opened in the former settlement as the first store in Japan to handle multiple brands. The space design with a circle motif is by Tokujin Yoshioka.",
		"store_hours": "Business hours 11:00 ー 20:00",
		"description_note": ""
	},
	{
		"id": 130,
		"shop_code": 64,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Hokkaido",
		"has_members": true,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": true,
		"is_reservation": false,
		"latitude": 43.058761,
		"longitude": 141.353183,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 34,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "hokkaido,sapporo,パルコ",
		"name": "BAO BAO ISSEY MIYAKE / SAPPORO PARCO",
		"tel": "011-222-7724",
		"fax": "",
		"zipcode": "060-8502",
		"address": "1F Sapporo PARCO, 3-3 Minami-1-jonishi, Chuo-ku, Sapporo-shi, Hokkaido",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 131,
		"shop_code": 65,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Miyagi",
		"has_members": true,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": true,
		"is_reservation": false,
		"latitude": 38.25905,
		"longitude": 140.880013,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 35,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "宫城,miyagi,sendai,パルコ",
		"name": "BAO BAO ISSEY MIYAKE / SENDAI PARCO2",
		"tel": "022-302-7693",
		"fax": "",
		"zipcode": "980-8450",
		"address": "Sendai PARCO2 2F, 3-7-5 Chuo, Aoba-ku, Sendai-shi, Miyagi",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 877,
		"shop_code": 271,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Osaka",
		"has_members": true,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": true,
		"is_reservation": true,
		"latitude": 34.673827,
		"longitude": 135.501183,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 36,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "四ツ橋,ミナミ,みなみ,御堂筋,yotsubashi,minami,midousuji,四桥,南",
		"name": "BAO BAO ISSEY MIYAKE / SHINSAIBASHI PARCO",
		"tel": "06-6281-1056",
		"fax": "",
		"zipcode": "542-0085",
		"address": "1F Shinsaibashi PARCO, 1-8-3 Shinsaibashisuji, Chuo-ku, Osaka-shi, Osaka",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 143,
		"shop_code": 75,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Hyogo",
		"has_members": true,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": true,
		"is_reservation": true,
		"latitude": 34.687168,
		"longitude": 135.190438,
		"google_business_url": "https://www.google.com/maps/place/BAO+BAO+ISSEY+MIYAKE+%2F+KOBE/@34.687162,135.1881253,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x389e490ad0af8f1c!8m2!3d34.687162!4d135.190314?",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0669/4479/4929/files/BB_kobe_fcc5c23c-9408-4754-9a1e-08dc65dc37da.jpg?v=1676645686",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 37,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "大丸,元町,三宮,daimaru,motomachi,sannomiya",
		"name": "BAO BAO ISSEY MIYAKE / KOBE",
		"tel": "078-392-2227",
		"fax": "",
		"zipcode": "650-0039",
		"address": "NTT Nishinihon Shinkobe Bldg., 1 Maemachi, Chuo-ku, Kobe-shi, Hyogo",
		"description": "A store with a rich lineup of BAO BAO ISSEY MIYAKE in a metallic space that mixes straight lines and curves.",
		"store_hours": "Business hours 11:00 ー 20:00",
		"description_note": ""
	},
	{
		"id": 753,
		"shop_code": 238,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": true,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": true,
		"is_reservation": false,
		"latitude": 35.658777,
		"longitude": 139.703227,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 38,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,shibuya,涩谷,ヒカリエ",
		"name": "me ISSEY MIYAKE / SHIBUYA HIKARIE",
		"tel": "03-6434-1694",
		"fax": "",
		"zipcode": "150-8509",
		"address": "3F, Shibuya Hikarie ShinQs, 2-21-1 Shibuya, Shibuka-ku, Tokyo",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1012,
		"shop_code": 310,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": true,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": true,
		"is_reservation": false,
		"latitude": 35.662216,
		"longitude": 139.698891,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 39,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "GOOD GOODS ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,パルコ,公園通り,koendori,公园通,shibuya",
		"name": "GOOD GOODS ISSEY MIYAKE / SHIBUYA PARCO",
		"tel": "03-6416-0929",
		"fax": "",
		"zipcode": "150-8377",
		"address": "3F, Shibuya Parco, 15-1 Udagawa-cho, Shibuya-ku, Tokyo",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 749,
		"shop_code": 236,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Hokkaido",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 43.067398,
		"longitude": 141.349202,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 40,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "hokkaido,sapporo,大丸,daimaru",
		"name": "ISSEY MIYAKE DAIMARU SAPPORO",
		"tel": "011-213-1119",
		"fax": "",
		"zipcode": "060-0005",
		"address": "5F, 4-7 Kita-5-jonishi, Chuo-ku, Sapporo-shi, Hokkaido",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 37,
		"shop_code": 15,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Hokkaido",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 43.067583,
		"longitude": 141.349461,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 41,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "hokkaido,sapporo,大丸,daimaru",
		"name": "PLEATS PLEASE ISSEY MIYAKE DAIMARU SAPPORO",
		"tel": "011-222-1165",
		"fax": "",
		"zipcode": "060-0005",
		"address": "5F, 4-7 Kita-5-jonishi, Chuo-ku, Sapporo-shi, Hokkaido",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 105,
		"shop_code": 50,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Hokkaido",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 43.067596,
		"longitude": 141.349558,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 42,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "hokkaido,sapporo,大丸,daimaru",
		"name": "me ISSEY MIYAKE DAIMARU SAPPORO",
		"tel": "011-522-6544",
		"fax": "",
		"zipcode": "060-0005",
		"address": "5F, 4-7 Kita-5-jonishi, Chuo-ku, Sapporo-shi, Hokkaido",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 36,
		"shop_code": 14,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Hokkaido",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 43.059421,
		"longitude": 141.353222,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 43,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "hokkaido,sapporo,三越,mitsukoshi",
		"name": "PLEATS PLEASE ISSEY MIYAKE SAPPORO MITSUKOSHI",
		"tel": "011-271-0611",
		"fax": "",
		"zipcode": "060-0061",
		"address": "4F, Main Bldg., 3-8 Minami-1-jonishi, Chuo-ku, Sapporo-shi, Hokkaido",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 104,
		"shop_code": 49,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Hokkaido",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 43.059296,
		"longitude": 141.353043,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 44,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "hokkaido,sapporo,三越,mitsukoshi",
		"name": "me ISSEY MIYAKE SAPPORO MITSUKOSHI",
		"tel": "011-200-1536",
		"fax": "",
		"zipcode": "060-0061",
		"address": "4F, Main Bldg., 3-8 Minami-1-jonishi, Chuo-ku, Sapporo-shi, Hokkaido",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 38,
		"shop_code": 16,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Miyagi",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 38.265089,
		"longitude": 140.871355,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 45,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "宫城,miyagi,sendai,三越,mitsukoshi",
		"name": "PLEATS PLEASE ISSEY MIYAKE SENDAI MITSUKOSHI",
		"tel": "022-221-2604",
		"fax": "",
		"zipcode": "980-8543",
		"address": "2F, 4-8-15 Ichibancho, Aoba-ku, Sendai-shi, Miyagi",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 106,
		"shop_code": 51,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Miyagi",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 38.265111,
		"longitude": 140.871296,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 46,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "宫城,miyagi,sendai,三越,mitsukoshi",
		"name": "me ISSEY MIYAKE SENDAI MITSUKOSHI",
		"tel": "022-221-2604",
		"fax": "",
		"zipcode": "980-8543",
		"address": "2F, 4-8-15 Ichibancho, Aoba-ku, Sendai-shi, Miyagi",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 5,
		"shop_code": 2,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.67238096,
		"longitude": 139.7666855,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 47,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,有楽町,yurakucho,有乐町",
		"name": "ISSEY MIYAKE MATSUYA GINZA",
		"tel": "03-3564-6233",
		"fax": "",
		"zipcode": "104-8130",
		"address": "4F, 3-6-1 Ginza, Chuo-ku, Tokyo",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 50,
		"shop_code": 23,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.67225395,
		"longitude": 139.7665406,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 48,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,ginza,银座,有楽町,yurakucho,有乐町",
		"name": "PLEATS PLEASE ISSEY MIYAKE MATSUYA GINZA",
		"tel": "03-5250-6340",
		"fax": "",
		"zipcode": "104-8130",
		"address": "4F, 3-6-1 Ginza, Chuo-ku, Tokyo",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 135,
		"shop_code": 69,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.67184545,
		"longitude": 139.7663582,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 49,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,ginza,银座,有楽町,yurakucho,有乐町",
		"name": "BAO BAO ISSEY MIYAKE MATSUYA GINZA",
		"tel": "03-3535-8080",
		"fax": "",
		"zipcode": "104-8130",
		"address": "1F, 3-6-1 Ginza, Chuo-ku, Tokyo",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 113,
		"shop_code": 53,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.67229518,
		"longitude": 139.7665925,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 50,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,ginza,银座,有楽町,yurakucho,有乐町",
		"name": "me ISSEY MIYAKE MATSUYA GINZA",
		"tel": "03-5159-0797",
		"fax": "",
		"zipcode": "104-8130",
		"address": "4F, 3-6-1 Ginza, Chuo-ku, Tokyo",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 86,
		"shop_code": 45,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.673446,
		"longitude": 139.762384,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/HP_HANKYU_MEN_S2025aug01_01.jpg?v=1753952304",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 51,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,銀座,ginza,银座,阪急,hankyu,メンズ",
		"name": "HOMME PLISSÉ ISSEY MIYAKE HANKYU MEN’S TOKYO",
		"tel": "03-6252-5330",
		"fax": "",
		"zipcode": "100-8488",
		"address": "6F, 2-5-1 Yurakucho, Chiyoda-ku, Tokyo",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 685,
		"shop_code": 225,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.673624,
		"longitude": 139.762412,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 52,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,銀座,ginza,银座,阪急,hankyu,メンズ",
		"name": "BAO BAO ISSEY MIYAKE HANKYU MEN’S TOKYO",
		"tel": "03-6280-6556",
		"fax": "",
		"zipcode": "100-8488",
		"address": "2F, 2-5-1 Yurakucho, Chiyoda-ku, Tokyo",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 7,
		"shop_code": 4,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.68518,
		"longitude": 139.77379,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 53,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,nihonbashi,日本桥,三越,mitsukoshi",
		"name": "ISSEY MIYAKE NIHOMBASHI MITSUKOSHI MAIN STORE",
		"tel": "03-3242-2086",
		"fax": "",
		"zipcode": "103-8001",
		"address": "3F New Bldg., 1-4-1 Nihombashimuromachi, Chuo-ku, Tokyo",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 51,
		"shop_code": 24,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.685257,
		"longitude": 139.774092,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 54,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,nihonbashi,日本桥,三越,mitsukoshi",
		"name": "PLEATS PLEASE ISSEY MIYAKE NIHOMBASHI MITSUKOSHI MAIN STORE",
		"tel": "03-3231-3008",
		"fax": "",
		"zipcode": "103-8001",
		"address": "3F New Bldg., 1-4-1 Nihombashimuromachi, Chuo-ku, Tokyo",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 114,
		"shop_code": 54,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.685212,
		"longitude": 139.773929,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 55,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,nihonbashi,日本桥,三越,mitsukoshi",
		"name": "me ISSEY MIYAKE NIHOMBASHI MITSUKOSHI MAIN STORE",
		"tel": "03-3231-3008",
		"fax": "",
		"zipcode": "103-8001",
		"address": "3F New Bldg., 1-4-1 Nihombashimuromachi, Chuo-ku, Tokyo",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 6,
		"shop_code": 3,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.680817,
		"longitude": 139.773832,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 56,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,nihonbashi,日本桥,タカシマヤ,tanashimaya",
		"name": "ISSEY MIYAKE TAKASHIMAYA NIHOMBASHI STORE",
		"tel": "03-3243-0201",
		"fax": "",
		"zipcode": "103-8265",
		"address": "4F, Main Bldg., 2-4-1 Nihombashi, Chuo-ku, Tokyo",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 681,
		"shop_code": 222,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.681007,
		"longitude": 139.773272,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 57,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,nihonbashi,日本桥,タカシマヤ,tanashimaya",
		"name": "PLEATS PLEASE ISSEY MIYAKE TAKASHIMAYA NIHOMBASHI STORE",
		"tel": "03-6281-9039",
		"fax": "",
		"zipcode": "103-8265",
		"address": "4F, Main Bldg., 2-4-1 Nihombashi, Chuo-ku, Tokyo",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 682,
		"shop_code": 223,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.68098,
		"longitude": 139.773237,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 58,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,nihonbashi,日本桥,タカシマヤ,tanashimaya",
		"name": "me ISSEY MIYAKE TAKASHIMAYA NIHOMBASHI STORE",
		"tel": "03-6281-9039",
		"fax": "",
		"zipcode": "103-8265",
		"address": "4F, Main Bldg., 2-4-1 Nihombashi, Chuo-ku, Tokyo",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 49,
		"shop_code": 22,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.681284,
		"longitude": 139.768849,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 59,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,ginza,银座,有楽町,yurakucho,有乐町,daimaru",
		"name": "PLEATS PLEASE ISSEY MIYAKE DAIMARU TOKYO",
		"tel": "03-6269-9074",
		"fax": "",
		"zipcode": "100-6701",
		"address": "6F, 1-9-1 Marunouchi, Chiyoda-ku, Tokyo",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 688,
		"shop_code": 228,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo Government",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.681347,
		"longitude": 139.768867,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 60,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,ginza,银座,有楽町,yurakucho,有乐町,daimaru",
		"name": "me ISSEY MIYAKE DAIMARU TOKYO",
		"tel": "03-6269-9074",
		"fax": "",
		"zipcode": "100-6701",
		"address": "6F, 1-9-1 Marunouchi, Chiyoda-ku, Tokyo",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 786,
		"shop_code": 249,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.69113909,
		"longitude": 139.7048013,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 61,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,新宿,shinjyuku,新宿三丁目,shinjukusanchome,伊勢丹,isetan",
		"name": "BAO BAO ISSEY MIYAKE SHINJUKU ISETAN",
		"tel": "03-5315-4475",
		"fax": "",
		"zipcode": "160-0022",
		"address": "1F, Main Bldg., 3-14-1 Shinjuku, Shinjuku-ku, Tokyo",
		"description": "",
		"store_hours": "*Repair service for items purchased in Japan is only available for pickup at the ISETAN SHINJUKU store.",
		"description_note": ""
	},
	{
		"id": 1034,
		"shop_code": 342,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.69113909,
		"longitude": 139.7048013,
		"google_business_url": "https://www.google.com/maps/place/GOOD+GOODS+ISSEY+MIYAKE+%E4%BC%8A%E5%8B%A2%E4%B8%B9+%E6%96%B0%E5%AE%BF%E5%BA%97/@35.691612,139.7046995,754m/data=!3m2!1e3!4b1!4m6!3m5!1s0x60188d494fb17a27:0xf9d2415911d7a90!8m2!3d35.691612!4d139.7046995!16s%2Fg%2F11ytt2h5tc?authuser=0&hl=ja&entry=ttu&g_ep=EgoyMDI1MTIwOS4wIKXMDSoKLDEwMDc5MjA2OUgBUAM%3D",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 62,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "GOOD GOODS ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,新宿,shinjyuku,新宿三丁目,shinjukusanchome,伊勢丹,isetan",
		"name": "GOOD GOODS ISSEY MIYAKE SHINJUKU ISETAN",
		"tel": "03-3352-1111",
		"fax": "",
		"zipcode": "160-0022",
		"address": "ISETAN Seed 1F, Main Bldg., 3-14-1 Shinjuku, Shinjuku-ku, Tokyo",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 53,
		"shop_code": 26,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.690427,
		"longitude": 139.699118,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 63,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,新宿,shinjyuku,京王,keio",
		"name": "PLEATS PLEASE ISSEY MIYAKE KEIO DEPARTMENT STORE SHINJUKU",
		"tel": "03-5908-3055",
		"fax": "",
		"zipcode": "160-8321",
		"address": "3F, 1-1-4 Nishi-Shinjuku, Shinjuku-ku, Tokyo",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 115,
		"shop_code": 55,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.690352,
		"longitude": 139.698923,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 64,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,新宿,shinjyuku,京王,keio",
		"name": "me ISSEY MIYAKE KEIO DEPARTMENT STORE SHINJUKU",
		"tel": "03-5321-8574",
		"fax": "",
		"zipcode": "160-8321",
		"address": "3F, 1-1-4 Nishi-Shinjuku, Shinjuku-ku, Tokyo",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 136,
		"shop_code": 70,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.6877,
		"longitude": 139.702189,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 65,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "新宿,shinjyuku,タカシマヤ,takashimaya",
		"name": "BAO BAO ISSEY MIYAKE TAKASHIMAYA SHINJUKU STORE",
		"tel": "03-3226-5030",
		"fax": "",
		"zipcode": "151-8580",
		"address": "3F, 5-24-2 Sendagaya, Shibuya-ku, Tokyo",
		"description": "",
		"store_hours": "*Repair service for items purchased in Japan is only available for pickup at the TAKASHIMAYA SHINJUKU store.",
		"description_note": ""
	},
	{
		"id": 117,
		"shop_code": 56,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.687348,
		"longitude": 139.702204,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 66,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "新宿,shinjyuku,タカシマヤ,takashimaya",
		"name": "me ISSEY MIYAKE TAKASHIMAYA SHINJUKU STORE",
		"tel": "03-3359-3324",
		"fax": "",
		"zipcode": "151-8580",
		"address": "5F, 5-24-2 Sendagaya, Shibuya-ku, Tokyo",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 57,
		"shop_code": 28,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.730763,
		"longitude": 139.710672,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 67,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,ikebukuro,東武,tobu",
		"name": "PLEATS PLEASE ISSEY MIYAKE TOBU DEPARTMENT STORE IKEBUKURO",
		"tel": "03-5951-8163",
		"fax": "",
		"zipcode": "171-8512",
		"address": "4F, 1-1-25 Nishiikebukuro, Toshima-ku, Tokyo",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 118,
		"shop_code": 57,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tokyo",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.730375,
		"longitude": 139.710421,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 68,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "tokyo,东京,ikebukuro,東武,tobu",
		"name": "me ISSEY MIYAKE TOBU DEPARTMENT STORE IKEBUKURO",
		"tel": "03-5957-3240",
		"fax": "",
		"zipcode": "171-8512",
		"address": "4F, 1-1-25 Nishiikebukuro, Toshima-ku, Tokyo",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 14,
		"shop_code": 8,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Aichi",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.171157,
		"longitude": 136.88374,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 69,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "爱知,aichi,nagoya,jr,ジェイアール,タカシマヤ,takashimaya",
		"name": "ISSEY MIYAKE JR NAGOYA TAKASHIMAYA",
		"tel": "052-566-8255",
		"fax": "",
		"zipcode": "450-6001",
		"address": "6F, 1-1-4 Meieki, Nakamura-ku, Nagoya-shi, Aichi",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 62,
		"shop_code": 29,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Aichi",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.171115,
		"longitude": 136.883728,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 70,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "爱知,aichi,nagoya,jr,ジェイアール,タカシマヤ,takashimaya",
		"name": "PLEATS PLEASE ISSEY MIYAKE JR NAGOYA TAKASHIMAYA",
		"tel": "052-566-8637",
		"fax": "",
		"zipcode": "450-6001",
		"address": "6F, 1-1-4 Meieki, Nakamura-ku, Nagoya-shi, Aichi",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 138,
		"shop_code": 71,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Aichi",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.170827,
		"longitude": 136.88334,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 71,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "爱知,aichi,nagoya,jr,ジェイアール,タカシマヤ,takashimaya",
		"name": "BAO BAO ISSEY MIYAKE JR NAGOYA TAKASHIMAYA",
		"tel": "052-561-1688",
		"fax": "",
		"zipcode": "450-6001",
		"address": "3F, 1-1-4, Meieki, Nakamura-ku, Nagoya-shi, Aichi",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1020,
		"shop_code": 318,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Aichi",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.171115,
		"longitude": 136.883728,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 72,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "爱知,aichi,nagoya,jr,ジェイアール,タカシマヤ,takashimaya,高島屋",
		"name": "me ISSEY MIYAKE JR NAGOYA TAKASHIMAYA",
		"tel": "052-433-1233",
		"fax": "",
		"zipcode": "450-6001",
		"address": "6F, 1-1-4 Meieki, Nakamura Ward, Nagoya City, Aichi Prefecture",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 63,
		"shop_code": 30,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Aichi",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.168617,
		"longitude": 136.907857,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 73,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "爱知,aichi,nagoya,sakae,三越,mitsukoshi",
		"name": "PLEATS PLEASE ISSEY MIYAKE NAGOYA SAKAE MITSUKOSHI",
		"tel": "052-252-1829",
		"fax": "",
		"zipcode": "460-8669",
		"address": "3F, 3-5-1 Sakae, Naka-ku, Nagoya City, Aichi Prefecture",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 120,
		"shop_code": 58,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Aichi",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.168614,
		"longitude": 136.907767,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 74,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "爱知,aichi,nagoya,sakae,三越,mitsukoshi",
		"name": "me ISSEY MIYAKE NAGOYA SAKAE MITSUKOSHI",
		"tel": "052-252-1829",
		"fax": "",
		"zipcode": "460-8669",
		"address": "3F, 3-5-1 Sakae, Naka-ku, Nagoya City, Aichi Prefecture",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 15,
		"shop_code": 9,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Kyoto",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 34.98567695,
		"longitude": 135.7578285,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 75,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "kyoto,jr,ジェイアール,isetan",
		"name": "ISSEY MIYAKE JR KYOTO ISETAN",
		"tel": "075-344-8373",
		"fax": "",
		"zipcode": "600-8555",
		"address": "5F, Higashi-shiokoji, shiokoji-sagaru, Karasuma-dori, shimogyou-ku, Kyoto-shi, Kyoto",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 65,
		"shop_code": 31,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "KYOTO",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 34.98596927,
		"longitude": 135.7573743,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 76,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "kyoto,jr,ジェイアール,isetan",
		"name": "PLEATS PLEASE ISSEY MIYAKE JR KYOTO ISETAN",
		"tel": "075-342-5691",
		"fax": "",
		"zipcode": "600-8555",
		"address": "4F, Higashi-shiokoji, shiokoji-sagaru, Karasuma-dori, shimogyou-ku, Kyoto-shi, Kyoto",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 790,
		"shop_code": 251,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Kyoto",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 34.98598697,
		"longitude": 135.7574424,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 77,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "kyoto,jr,ジェイアール,isetan",
		"name": "me ISSEY MIYAKE JR KYOTO ISETAN",
		"tel": "075-342-5691",
		"fax": "",
		"zipcode": "600-8555",
		"address": "4F, Higashi-shiokoji, shiokoji-sagaru, Karasuma-dori, shimogyou-ku, Kyoto-shi, Kyoto",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 66,
		"shop_code": 32,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "KYOTO",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.003274,
		"longitude": 135.768949,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 78,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "kyoto,タカシマヤ,takashimaya",
		"name": "PLEATS PLEASE ISSEY MIYAKE TAKASHIMAYA KYOTO STORE",
		"tel": "075-279-2445",
		"fax": "",
		"zipcode": "600-8520",
		"address": "3F, 52 Nishiiru, Shincho, Shijo-dori, Kawaramachi, Shimogyo-ku, Kyoto-shi, Kyoto",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 122,
		"shop_code": 59,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Kyoto",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.003058,
		"longitude": 135.768776,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 79,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "kyoto,タカシマヤ,takashimaya",
		"name": "me ISSEY MIYAKE TAKASHIMAYA KYOTO STORE",
		"tel": "075-279-2445",
		"fax": "",
		"zipcode": "600-8520",
		"address": "3F, 52 Nishiiru, Shincho, Shijo-dori, Kawaramachi, Shimogyo-ku, Kyoto-shi, Kyoto",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 18,
		"shop_code": 10,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Osaka",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 34.702308,
		"longitude": 135.498847,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 80,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "梅田,umeda,阪急,hankyu",
		"name": "ISSEY MIYAKE HANKYU DEPARTMENT STORE UMEDA MAIN STORE",
		"tel": "06-6313-7398",
		"fax": "",
		"zipcode": "530-8350",
		"address": "3F, 8-7 Kakudacho, Kita-ku, Osaka-shi, Osaka",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 72,
		"shop_code": 37,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Osaka",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 34.702599,
		"longitude": 135.498353,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/PL_HANKYUUMEDA_2025dec04_01.jpg?v=1764822350",
		"img2": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/PL_HANKYUUMEDA_2025dec04_02.jpg?v=1764822350",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 81,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "osaka,阪急,hankyu,梅田,うめだ,umeda",
		"name": "PLEATS PLEASE ISSEY MIYAKE HANKYU DEPARTMENT STORE UMEDA MAIN STORE",
		"tel": "06-6313-0692",
		"fax": "",
		"zipcode": "530-8350",
		"address": "7F, 8-7 Kakudacho, Kita-ku, Osaka-shi, Osaka",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 140,
		"shop_code": 73,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Osaka",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 34.702298,
		"longitude": 135.498489,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 82,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "osaka,阪急,hankyu,梅田,うめだ,umeda",
		"name": "BAO BAO ISSEY MIYAKE HANKYU DEPARTMENT STORE UMEDA MAIN STORE",
		"tel": "06-6313-7238",
		"fax": "",
		"zipcode": "530-8350",
		"address": "1F, 8-7 Kakudacho, Kita-ku, Osaka-shi, Osaka",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 123,
		"shop_code": 60,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Osaka",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 34.702636,
		"longitude": 135.498343,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/MI_HANKYUUMEDA_2025dec04_01.jpg?v=1764822359",
		"img2": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/MI_HANKYUUMEDA_2025dec04_02.jpg?v=1764822359",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 83,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "osaka,阪急,hankyu,梅田,うめだ,umeda",
		"name": "me ISSEY MIYAKE HANKYU DEPARTMENT STORE UMEDA MAIN STORE",
		"tel": "06-6313-0525",
		"fax": "",
		"zipcode": "530-8350",
		"address": "7F, 8-7 Kakudacho, Kita-ku, Osaka-shi, Osaka",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1006,
		"shop_code": 304,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Osaka",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 34.70347359,
		"longitude": 135.4998505,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/LA_HANKYU_MEN_S2026jan20_01.jpg?v=1768871320",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 84,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "IM MEN",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "osaka,阪急,hankyu,梅田,umeda,阪急,hankyu,メンズ",
		"name": "IM MEN HANKYU MEN’S OSAKA",
		"tel": "06-6313-9806",
		"fax": "",
		"zipcode": "530-0017",
		"address": "5F, 7-10 Kakudacho, Kita-ku, Osaka-shi, Osaka",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 965,
		"shop_code": 290,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Osaka",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 34.70347359,
		"longitude": 135.4998505,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 85,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "osaka,阪急,hankyu,梅田,umeda,阪急,hankyu,メンズ",
		"name": "HOMME PLISSÉ ISSEY MIYAKE HANKYU MEN’S OSAKA",
		"tel": "06-6313-9826",
		"fax": "",
		"zipcode": "530-0017",
		"address": "5F, 7-10 Kakudacho, Kita-ku, Osaka-shi, Osaka",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 141,
		"shop_code": 74,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Osaka",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 34.70329231,
		"longitude": 135.5000871,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 86,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "osaka,阪急,hankyu,梅田,umeda,阪急,hankyu,メンズ",
		"name": "BAO BAO ISSEY MIYAKE HANKYU MEN’S OSAKA",
		"tel": "06-6315-3211",
		"fax": "",
		"zipcode": "530-0017",
		"address": "1F, 7-10 Kakudacho, Kita-ku, Osaka-shi, Osaka",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 71,
		"shop_code": 36,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Osaka",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 34.701352,
		"longitude": 135.497965,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 87,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "osaka,阪神,hanshin,梅田,うめだ,umeda",
		"name": "PLEATS PLEASE ISSEY MIYAKE HANSHIN UMEDA MAIN STORE",
		"tel": "080-9584-9658",
		"fax": "",
		"zipcode": "530-8224",
		"address": "5F, 1-13-13 Umeda, Kita-ku, Osaka, Osaka",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 19,
		"shop_code": 11,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Osaka",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 34.664356,
		"longitude": 135.501931,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 88,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "osaka,タカシマヤ,takashimaya",
		"name": "ISSEY MIYAKE TAKASHIMAYA OSAKA STORE",
		"tel": "06-6632-9288",
		"fax": "",
		"zipcode": "542-8510",
		"address": "4F, 5-1-5 Namba, Chuo-ku, Osaka-shi, Osaka",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 73,
		"shop_code": 38,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Osaka",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 34.664832,
		"longitude": 135.501169,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_PL_2025may15_01_96ffaefe-aa3c-4c52-8763-3f5c5e45261d.jpg?v=1747293868",
		"img2": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_PL_2025may15_02_fa1ec366-e2cc-4045-b65f-cda76f8715d4.jpg?v=1747293868",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 89,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "osaka,タカシマヤ,takashimaya",
		"name": "PLEATS PLEASE ISSEY MIYAKE TAKASHIMAYA OSAKA STORE",
		"tel": "06-6632-9590",
		"fax": "",
		"zipcode": "542-8510",
		"address": "4F, 5-1-5 Namba, Chuo-ku, Osaka-shi, Osaka",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 690,
		"shop_code": 230,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Osaka",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 34.664705,
		"longitude": 135.500351,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 90,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "osaka,タカシマヤ,takashimaya",
		"name": "HOMME PLISSÉ ISSEY MIYAKE TAKASHIMAYA OSAKA STORE",
		"tel": "06-6632-9068",
		"fax": "",
		"zipcode": "542-8510",
		"address": "3F, 5-1-5 Namba, Chuo-ku, Osaka-shi, Osaka",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 124,
		"shop_code": 61,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Osaka",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 34.664831,
		"longitude": 135.501224,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_MI_2025may15_01_2a5e5b77-3271-4683-a4d4-212f564f6e5b.jpg?v=1747293860",
		"img2": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/CPS_MI_2025may15_02_388c305f-bcd7-4454-8cae-d524d3924bae.jpg?v=1747293861",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 91,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "osaka,タカシマヤ,takashimaya",
		"name": "me ISSEY MIYAKE TAKASHIMAYA OSAKA STORE",
		"tel": "06-6631-1733",
		"fax": "",
		"zipcode": "542-8510",
		"address": "4F, 5-1-5 Namba, Chuo-ku, Osaka-shi, Osaka",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 69,
		"shop_code": 34,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "OSAKA",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 34.646159,
		"longitude": 135.513389,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 92,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "osaka,近鉄,kintetsu,あべのハルカス,abenoharukas",
		"name": "PLEATS PLEASE ISSEY MIYAKE KINTETSU DEPARTMENT STORE MAIN STORE ABENO HARUKAS",
		"tel": "06-6622-2737",
		"fax": "",
		"zipcode": "545-8545",
		"address": "5F Tower Bldg., 1-1-43 Abenosuji, Abeno-ku, Osaka-shi, Osaka",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 139,
		"shop_code": 72,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Osaka",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 34.645957,
		"longitude": 135.513488,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 93,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "osaka,近鉄,kintetsu,あべのハルカス,abenoharukas",
		"name": "BAO BAO ISSEY MIYAKE KINTETSU DEPARTMENT STORE MAIN STORE ABENO HARUKAS",
		"tel": "06-6654-6268",
		"fax": "",
		"zipcode": "545-8545",
		"address": "1F Tower Bldg., 1-1-43 Abenosuji, Abeno-ku, Osaka-shi, Osaka",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 24,
		"shop_code": 13,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Fukuoka",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 33.588854,
		"longitude": 130.397923,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 94,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "132 5. ISSEY MIYAKE",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "福冈,fukuoka,岩田屋,iwataya,",
		"name": "ISSEY MIYAKE IWATAYA",
		"tel": "092-723-0281",
		"fax": "",
		"zipcode": "810-8680",
		"address": "4F Main Bldg., 2-5-35 Tenjin, Chuo-ku, Fukuoka-shi, Fukuoka",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 78,
		"shop_code": 39,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Fukuoka",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 33.589055,
		"longitude": 130.397855,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 95,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "福冈,fukuoka,岩田屋,iwataya",
		"name": "PLEATS PLEASE ISSEY MIYAKE IWATAYA",
		"tel": "092-725-6583",
		"fax": "",
		"zipcode": "810-8680",
		"address": "4F Main Bldg., 2-5-35 Tenjin, Chuo-ku, Fukuoka-shi, Fukuoka",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 144,
		"shop_code": 76,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Fukuoka",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 33.589389,
		"longitude": 130.397652,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 96,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "福冈,fukuoka,岩田屋,iwataya",
		"name": "BAO BAO ISSEY MIYAKE IWATAYA",
		"tel": "092-725-3988",
		"fax": "",
		"zipcode": "810-8680",
		"address": "New Building 1F, 2-5-35 Tenjin, Chuo-ku, Fukuoka-shi, Fukuoka",
		"description": "",
		"store_hours": "*Repair service for items purchased in Japan is only available for pickup at the IWATAYA store.",
		"description_note": ""
	},
	{
		"id": 127,
		"shop_code": 62,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Fukuoka",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 33.589029,
		"longitude": 130.397742,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 97,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "福冈,fukuoka,岩田屋,iwataya",
		"name": "me ISSEY MIYAKE IWATAYA",
		"tel": "092-725-6583",
		"fax": "",
		"zipcode": "810-8680",
		"address": "4F Main Bldg., 2-5-35 Tenjin, Chuo-ku, Fukuoka-shi, Fukuoka",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1003,
		"shop_code": 301,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Fukuoka",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 33.5897381815712,
		"longitude": 130.419878492954,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 98,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "IM MEN",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "福冈,fukuoka,阪急,hankyu,hakata",
		"name": "IM MEN HAKATA HANKYU DEPARTMENT STORE",
		"tel": "080-9584-9497",
		"fax": "",
		"zipcode": "812-0012",
		"address": "2F, 1-1 Chuougai, Hakataeki, Hakata-ku, Fukuoka-shi, Fukuoka",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 79,
		"shop_code": 40,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Fukuoka",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 33.589686,
		"longitude": 130.420531,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 99,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "福冈,fukuoka,阪急,hankyu,hakata",
		"name": "PLEATS PLEASE ISSEY MIYAKE HAKATA HANKYU DEPARTMENT STORE",
		"tel": "080-9584-9486",
		"fax": "",
		"zipcode": "812-0012",
		"address": "5F, 1-1 Chuougai, Hakataeki, Hakata-ku, Fukuoka-shi, Fukuoka",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 87,
		"shop_code": 46,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Fukuoka",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 33.589568,
		"longitude": 130.419863,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 100,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "福冈,fukuoka,阪急,hankyu",
		"name": "HOMME PLISSÉ ISSEY MIYAKE HAKATA HANKYU DEPARTMENT STORE",
		"tel": "080-9584-9448",
		"fax": "",
		"zipcode": "812-0012",
		"address": "2F, 1-1 Chuougai, Hakataeki, Hakata-ku, Fukuoka-shi, Fukuoka",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 145,
		"shop_code": 77,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Fukuoka",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 33.58936,
		"longitude": 130.420375,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 101,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "福冈,fukuoka,阪急,hankyu",
		"name": "BAO BAO ISSEY MIYAKE HAKATA HANKYU DEPARTMENT STORE",
		"tel": "080-9584-9506",
		"fax": "",
		"zipcode": "812-0012",
		"address": "1F, 1-1 Hakataeki, Chuogai, Hakata-ku, Fukuoka-shi, Fukuoka",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 128,
		"shop_code": 63,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Fukuoka",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 33.589622,
		"longitude": 130.420558,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 102,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "福冈,fukuoka,阪急,hankyu",
		"name": "me ISSEY MIYAKE HAKATA HANKYU DEPARTMENT STORE",
		"tel": "080-9584-9486",
		"fax": "",
		"zipcode": "812-0012",
		"address": "5F, 1-1 Chuougai, Hakataeki, Hakata-ku, Fukuoka-shi, Fukuoka",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1013,
		"shop_code": 311,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Chiba",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.763013,
		"longitude": 140.388003,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 103,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "PLEATS PLEASE ISSEY MIYAKE",
		"brand3": "BAO BAO ISSEY MIYAKE",
		"brand4": "me ISSEY MIYAKE",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "千叶,chiba,narita,airport,机场,成田,成田空港",
		"name": "ISSEY MIYAKE NARITA INTERNATIONAL AIRPORT TERMINAL 1",
		"tel": "0120-191-625",
		"fax": "",
		"zipcode": "282-0011",
		"address": "3F (After passport control), No.5 Satellite, Narita International Airport Terminal 1, Narita-shi, Chiba",
		"description": "",
		"store_hours": "*Repair service is unavailable at this location.",
		"description_note": ""
	},
	{
		"id": 781,
		"shop_code": 245,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Aichi",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 34.858621,
		"longitude": 136.81369,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 106,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "爱知,aichi,セントレア,空港,airport,机场",
		"name": "PLEATS PLEASE ISSEY MIYAKE CHUBU CENTRAIR INTERNATIONAL AIRPORT",
		"tel": "056-938-7122",
		"fax": "",
		"zipcode": "479-0881",
		"address": "1-1 Centrair, Tokoname City, Aichi Prefecture Chubu Centrair International Airport Centrair 3F (in the departure area)",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 782,
		"shop_code": 246,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Aichi",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 34.858659,
		"longitude": 136.813649,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 107,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "爱知,aichi,セントレア,空港,airport,机场",
		"name": "BAO BAO ISSEY MIYAKE CHUBU CENTRAIR INTERNATIONAL AIRPORT",
		"tel": "​0569-38-7122",
		"fax": "",
		"zipcode": "479-0881",
		"address": "1-1 Centrair, Tokoname City, Aichi Prefecture Chubu Centrair International Airport Centrair 3F (in the departure area)",
		"description": "",
		"store_hours": "*Repair service is unavailable at this location.",
		"description_note": ""
	},
	{
		"id": 1004,
		"shop_code": 302,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Fukuoka",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 33.585459,
		"longitude": 130.444477,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "https://cdn.shopify.com/s/files/1/0650/5981/5642/files/IM_FUKUOKAINTERNATIONALAIRPORT_25ARP02_01.jpg?v=1743555228",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 108,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "IM MEN",
		"brand3": "PLEATS PLEASE ISSEY MIYAKE",
		"brand4": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand5": "BAO BAO ISSEY MIYAKE",
		"brand6": "me ISSEY MIYAKE",
		"brand7": "GOOD GOODS ISSEY MIYAKE",
		"brand8": "ISSEY MIYAKE WATCH",
		"brand9": "ISSEY MIYAKE EYES",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "福冈,fukuoka,airport,机场",
		"name": "ISSEY MIYAKE FUKUOKA INTERNATIONAL AIRPORT",
		"tel": "+81-092-483-7003",
		"fax": "",
		"zipcode": "812-0851",
		"address": "739 Aoki, Hakata-ku, Fukuoka City, Fukuoka Prefecture Fukuoka Airport International Terminal 3F (inside the departure area)",
		"description": "",
		"store_hours": "*Repair service is unavailable at this location.",
		"description_note": ""
	},
	{
		"id": 550,
		"shop_code": 198,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.527433,
		"longitude": 127.027102,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 109,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "ISSEY MIYAKE HYUNDAI APGUJEONG MAIN",
		"tel": "+82-2-3438-6290",
		"fax": "",
		"zipcode": "-",
		"address": "3F, 165, Apgujeong-ro, Gangnam-gu, Seoul, 06001",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 228,
		"shop_code": 138,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.527619,
		"longitude": 127.027526,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 110,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "PLEATS PLEASE ISSEY MIYAKE HYUNDAI APGUJEONG MAIN",
		"tel": "+82-2-3449-5946",
		"fax": "",
		"zipcode": "-",
		"address": "3F, 165, Apgujeong-ro, Gangnam-gu, Seoul, 06001",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 701,
		"shop_code": 234,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.527594,
		"longitude": 127.027458,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 111,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "BAO BAO ISSEY MIYAKE HYUNDAI APGUJEONG MAIN",
		"tel": "+82-2-3449-5946",
		"fax": "",
		"zipcode": "-",
		"address": "3F, 165, Apgujeong-ro, Gangnam-gu, Seoul, 06001",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 862,
		"shop_code": 263,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.527487,
		"longitude": 127.027262,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 112,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "me ISSEY MIYAKE HYUNDAI APGUJEONG MAIN",
		"tel": "+82-2-3449-5946",
		"fax": "",
		"zipcode": "-",
		"address": "3F, 165, Apgujeong-ro, Gangnam-gu, Seoul, 06001",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 678,
		"shop_code": 220,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.538848,
		"longitude": 127.124211,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 113,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル",
		"name": "PLEATS PLEASE ISSEY MIYAKE HYUNDAI CHEONHO",
		"tel": "+82-2-2225-7266",
		"fax": "",
		"zipcode": "-",
		"address": "2F, 1005, Cheonhodae-ro, Gangdong-gu, Seoul, 05328",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 679,
		"shop_code": 221,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.53889,
		"longitude": 127.124186,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 114,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "BAO BAO ISSEY MIYAKE HYUNDAI CHEONHO",
		"tel": "+82-2-2225-7256",
		"fax": "",
		"zipcode": "-",
		"address": "2F, 1005, Cheonhodae-ro, Gangdong-gu, Seoul, 05328",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 239,
		"shop_code": 149,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.508815,
		"longitude": 127.059951,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 115,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "ISSEY MIYAKE HYUNDAI COEX",
		"tel": "+82-2-3467-8433",
		"fax": "",
		"zipcode": "-",
		"address": "3F, 517, Teheran-ro, Gangnam-gu, Seoul, 06164",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 240,
		"shop_code": 150,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.508762,
		"longitude": 127.059991,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 116,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "BAO BAO ISSEY MIYAKE",
		"brand3": "me ISSEY MIYAKE",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "PLEATS PLEASE ISSEY MIYAKE HYUNDAI COEX",
		"tel": "+82-2-3467-8533",
		"fax": "",
		"zipcode": "-",
		"address": "3F, 517, Teheran-ro, Gangnam-gu, Seoul, 06164",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 999,
		"shop_code": 297,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.511658,
		"longitude": 127.059182,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 117,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "HOMME PLISSÉ ISSEY MIYAKE HYUNDAI COEX",
		"tel": "+82-2-3467-8761",
		"fax": "",
		"zipcode": "-",
		"address": "7F, 517, Teheran-ro, Gangnam-gu, Seoul, 06164",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 561,
		"shop_code": 203,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.526749,
		"longitude": 126.875184,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 118,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "PLEATS PLEASE ISSEY MIYAKE HYUNDAI MOKDONG",
		"tel": "+82-2-2163-1290",
		"fax": "",
		"zipcode": "-",
		"address": "2F, 257 Mokdong-ro Yangcheon-gu, Seoul, 07998",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 508,
		"shop_code": 179,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.529048,
		"longitude": 126.87563,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 119,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "BAO BAO ISSEY MIYAKE HYUNDAI MOKDONG",
		"tel": "+82-2-2163-1287",
		"fax": "",
		"zipcode": "-",
		"address": "2F, 257 Mokdong-ro Yangcheon-gu, Seoul, 07998",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 232,
		"shop_code": 142,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.556218,
		"longitude": 126.935776,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 120,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "BAO BAO ISSEY MIYAKE",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "PLEATS PLEASE ISSEY MIYAKE HYUNDAI SHINCHON",
		"tel": "+82-2-3145-2488",
		"fax": "",
		"zipcode": "-",
		"address": "2F, 83, Sinchon-ro, Seodaemun-gu, Seoul, 03789",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 901,
		"shop_code": 275,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.52677447,
		"longitude": 126.9270498,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 121,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "me ISSEY MIYAKE",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "PLEATS PLEASE ISSEY MIYAKE THE HYUNDAI SEOUL",
		"tel": "+82-2-3277-0229",
		"fax": "",
		"zipcode": "-",
		"address": "2F, 108 Yeoui-daero, Yeongdeungpo-gu, Seoul, 07335",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1016,
		"shop_code": 314,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.5262454175321,
		"longitude": 126.928301318922,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 122,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "HOMME PLISSÉ ISSEY MIYAKE THE HYUNDAI SEOUL",
		"tel": "+82-2-3277-0233",
		"fax": "",
		"zipcode": "-",
		"address": "2F, 108 Yeoui-daero, Yeongdeungpo-gu, Seoul, 07335",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1015,
		"shop_code": 313,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.5262454175321,
		"longitude": 126.928301318922,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 123,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "BAO BAO ISSEY MIYAKE THE HYUNDAI SEOUL",
		"tel": "+82-2-3277-0250",
		"fax": "",
		"zipcode": "-",
		"address": "2F, 108 Yeoui-daero, Yeongdeungpo-gu, Seoul, 07335",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 229,
		"shop_code": 139,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.564772,
		"longitude": 126.981524,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 124,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "ISSEY MIYAKE LOTTE MAIN",
		"tel": "+82-2-2118-6099",
		"fax": "",
		"zipcode": "-",
		"address": "2F, 81, Namdaemun-ro, Jung-gu, Seoul, 04533",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 230,
		"shop_code": 140,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.564861,
		"longitude": 126.981672,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 125,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "PLEATS PLEASE ISSEY MIYAKE LOTTE MAIN",
		"tel": "+82-2-726-4460",
		"fax": "",
		"zipcode": "-",
		"address": "3F, 81, Namdaemun-ro, Jung-gu, Seoul, 04533",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 231,
		"shop_code": 141,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.56487,
		"longitude": 126.981501,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 126,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "BAO BAO ISSEY MIYAKE LOTTE MAIN",
		"tel": "+82-2-772-3407",
		"fax": "",
		"zipcode": "-",
		"address": "3F, 81, Namdaemun-ro, Jung-gu, Seoul, 04533",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 241,
		"shop_code": 151,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.497079,
		"longitude": 127.053241,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 127,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "BAO BAO ISSEY MIYAKE",
		"brand3": "me ISSEY MIYAKE",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "PLEATS PLEASE ISSEY MIYAKE LOTTE GANGNAM",
		"tel": "+82-2-531-2263",
		"fax": "",
		"zipcode": "-",
		"address": "4F, 401, Dogok-ro, Gangnam-gu, Seoul, 06206",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 233,
		"shop_code": 143,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.511764,
		"longitude": 127.097006,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 128,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "ISSEY MIYAKE LOTTE JAMSIL",
		"tel": "+82-2-2143-7213",
		"fax": "",
		"zipcode": "-",
		"address": "4F, 240, Olympic-ro, Songpa-gu, Seoul, 05554",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 234,
		"shop_code": 144,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.511825,
		"longitude": 127.097189,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 129,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "me ISSEY MIYAKE",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "PLEATS PLEASE ISSEY MIYAKE LOTTE JAMSIL",
		"tel": "+82-2-2143-7227",
		"fax": "",
		"zipcode": "-",
		"address": "4F, 240, Olympic-ro, Songpa-gu, Seoul, 05554",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 235,
		"shop_code": 145,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.511926,
		"longitude": 127.097619,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 130,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "BAO BAO ISSEY MIYAKE LOTTE JAMSIL",
		"tel": "+82-2-2143-1721",
		"fax": "",
		"zipcode": "-",
		"address": "1F, 240, Olympic-ro, Songpa-gu, Seoul, 05554",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1024,
		"shop_code": 322,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.51301,
		"longitude": 127.10173,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 131,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "me ISSEY MIYAKE LOTTE WORLD TOWER",
		"tel": "+81-2-3213-2569",
		"fax": "",
		"zipcode": "-",
		"address": "5F, 300 Olympic-ro, Songpa-gu, Seoul, 05551",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 225,
		"shop_code": 135,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.504079,
		"longitude": 127.003121,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 132,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "ISSEY MIYAKE SHINSEGAE GANGNAM",
		"tel": "+82-2-3479-1787",
		"fax": "",
		"zipcode": "-",
		"address": "3F, 176, Sinbanpo-ro, Seocho-gu, Seoul, 06546",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 226,
		"shop_code": 136,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.504256,
		"longitude": 127.00322,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 133,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "PLEATS PLEASE ISSEY MIYAKE SHINSEGAE GANGNAM",
		"tel": "+82-2-3479-1795",
		"fax": "",
		"zipcode": "-",
		"address": "4F, 176, Sinbanpo-ro, Seocho-gu, Seoul, 06546",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 876,
		"shop_code": 270,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.504176,
		"longitude": 127.003322,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 134,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "HOMME PLISSÉ ISSEY MIYAKE SHINSEGAE GANGNAM",
		"tel": "+82-2-3479-1466",
		"fax": "",
		"zipcode": "-",
		"address": "6F, 176, Sinbanpo-ro, Seocho-gu, Seoul, 06546",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 863,
		"shop_code": 264,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.503802,
		"longitude": 127.003376,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 135,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "me ISSEY MIYAKE SHINSEGAE GANGNAM",
		"tel": "+82-2-3479-1795",
		"fax": "",
		"zipcode": "-",
		"address": "4F, 176, Sinbanpo-ro, Seocho-gu, Seoul, 06546",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 227,
		"shop_code": 137,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.503995,
		"longitude": 127.003057,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 136,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "BAO BAO ISSEY MIYAKE SHINSEGAE GANGNAM",
		"tel": "+82-2-3479-6104",
		"fax": "",
		"zipcode": "-",
		"address": "4F, 176, Sinbanpo-ro, Seocho-gu, Seoul, 06546",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 236,
		"shop_code": 146,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.560976,
		"longitude": 126.981035,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 137,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "ISSEY MIYAKE SHINSEGAE MAIN",
		"tel": "+82-2-310-5358",
		"fax": "",
		"zipcode": "-",
		"address": "New Building 3F, Shinsegae Main, 63, Sogongno, Jung-gu, Seoul, 04530",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 237,
		"shop_code": 147,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.560965,
		"longitude": 126.981118,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 138,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "me ISSEY MIYAKE",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "PLEATS PLEASE ISSEY MIYAKE SHINSEGAE MAIN",
		"tel": "+82-2-310-1248",
		"fax": "",
		"zipcode": "-",
		"address": "New Building 3F, Shinsegae Main, 77, Toegye-ro, Jung-gu, Seoul, 04530",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 238,
		"shop_code": 148,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.5609,
		"longitude": 126.981079,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 139,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "BAO BAO ISSEY MIYAKE SHINSEGAE MAIN",
		"tel": "+82-2-310-1834",
		"fax": "",
		"zipcode": "-",
		"address": "New Building 3F, Shinsegae Main, 77, Toegye-ro, Jung-gu, Seoul, 04530",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 845,
		"shop_code": 259,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.517162,
		"longitude": 126.90555,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 140,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "PLEATS PLEASE ISSEY MIYAKE SHINSEGAE YEONGDEUNGPO",
		"tel": "+82-2-2639-1664",
		"fax": "",
		"zipcode": "-",
		"address": "2F, 9, Yeongjung-ro, Yeongdeungpo-gu, Seoul, 07305",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 846,
		"shop_code": 260,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.517247,
		"longitude": 126.905671,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 141,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "BAO BAO ISSEY MIYAKE SHINSEGAE YEONGDEUNGPO",
		"tel": "+82-2-2639-1377",
		"fax": "",
		"zipcode": "-",
		"address": "2F, 9, Yeongjung-ro, Yeongdeungpo-gu, Seoul, 07305",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 223,
		"shop_code": 134,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Seoul",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.557884,
		"longitude": 127.007623,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 142,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "PLEATS PLEASE ISSEY MIYAKE",
		"brand3": "BAO BAO ISSEY MIYAKE",
		"brand4": "me ISSEY MIYAKE",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ソウル,首尔",
		"name": "ISSEY MIYAKE SHILLA HOTEL",
		"tel": "+82-2-2231-6282",
		"fax": "",
		"zipcode": "-",
		"address": "B1, 249, Dongho-ro, Jung-gu, Seoul, 04605",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 260,
		"shop_code": 166,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Pusan",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.156833,
		"longitude": 129.056501,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 143,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "プサン,釜山",
		"name": "ISSEY MIYAKE LOTTE BUSAN",
		"tel": "+82-51-810-4217",
		"fax": "",
		"zipcode": "-",
		"address": "MB1F, 772, Gaya-daero, Busanjin-gu, Busan, 47285",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 261,
		"shop_code": 167,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Pusan",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.156829,
		"longitude": 129.056683,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 144,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "me ISSEY MIYAKE",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "プサン,釜山",
		"name": "PLEATS PLEASE ISSEY MIYAKE LOTTE BUSAN",
		"tel": "+82-51-810-4215",
		"fax": "",
		"zipcode": "-",
		"address": "MB1F, 772, Gaya-daero, Busanjin-gu, Busan, 47285",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 558,
		"shop_code": 201,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Pusan",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.15683,
		"longitude": 129.056598,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 145,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "プサン",
		"name": "BAO BAO ISSEY MIYAKE LOTTE BUSAN",
		"tel": "+82-51-810-3107",
		"fax": "",
		"zipcode": "-",
		"address": "MB1F, 772, Gaya-daero, Busanjin-gu, Busan, 47285",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 266,
		"shop_code": 170,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Pusan",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.168655,
		"longitude": 129.129708,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 146,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "BAO BAO ISSEY MIYAKE",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "プサン,釜山",
		"name": "ISSEY MIYAKE SHINSEGAE CENTUM CITY",
		"tel": "+82-51-745-2468",
		"fax": "",
		"zipcode": "-",
		"address": "2F, 35, Centum nam-daero, Haeundae-gu, Busan, 48058",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 268,
		"shop_code": 171,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Pusan",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.168965,
		"longitude": 129.129825,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 147,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "me ISSEY MIYAKE",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "プサン,釜山",
		"name": "PLEATS PLEASE ISSEY MIYAKE SHINSEGAE CENTUM CITY",
		"tel": "+82-51-745-2490",
		"fax": "",
		"zipcode": "-",
		"address": "2F, 35, Centum nam-daero, Haeundae-gu, Busan, 48059",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 902,
		"shop_code": 276,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Pusan",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.16887859,
		"longitude": 129.1297788,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 148,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "プサン,釜山",
		"name": "HOMME PLISSÉ ISSEY MIYAKE SHINSEGAE CENTUM CITY",
		"tel": "+82-51-745-2776",
		"fax": "",
		"zipcode": "-",
		"address": "5F, 35, Centum nam-daero, Haeundae-gu, Busan, 48059",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 253,
		"shop_code": 161,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "tegu",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.866408,
		"longitude": 128.590747,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 149,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "テグ,大邱",
		"name": "ISSEY MIYAKE HYUNDAI DAEGU",
		"tel": "+82-53-245-2225",
		"fax": "",
		"zipcode": "-",
		"address": "2F, 2077, Dalgubeol-daero, Jung-gu, Daegu, 41936",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 255,
		"shop_code": 162,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "tegu",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.866456,
		"longitude": 128.59057,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 150,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "me ISSEY MIYAKE",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "テグ,大邱",
		"name": "PLEATS PLEASE ISSEY MIYAKE HYUNDAI DAEGU",
		"tel": "+82-53-245-2242",
		"fax": "",
		"zipcode": "-",
		"address": "2F, 2077, Dalgubeol-daero, Jung-gu, Daegu, 41936",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 864,
		"shop_code": 265,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Taegu",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.87597,
		"longitude": 128.596587,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 151,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "テグ,大邱",
		"name": "me ISSEY MIYAKE LOTTE DAEGU",
		"tel": "+82-53-660-3095",
		"fax": "",
		"zipcode": "-",
		"address": "2F, 161, Taepyeong-ro, Buk-gu, Daegu, 41581",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 257,
		"shop_code": 163,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "teg",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.877652,
		"longitude": 128.628572,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 152,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "テグ,大邱",
		"name": "ISSEY MIYAKE SHINSEGAE DAEGU",
		"tel": "+82-53-661-6362",
		"fax": "",
		"zipcode": "-",
		"address": "4F, 149, Dongbu-ro, Dong-gu, Daegu, 41229",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 258,
		"shop_code": 164,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "teg",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.87775,
		"longitude": 128.628529,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 153,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "テグ,大邱",
		"name": "PLEATS PLEASE ISSEY MIYAKE SHINSEGAE DAEGU",
		"tel": "+82-53-661-6369",
		"fax": "",
		"zipcode": "-",
		"address": "4F, 149, Dongbu-ro, Dong-gu, Daegu, 41229",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 259,
		"shop_code": 165,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Daegu",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.877768,
		"longitude": 128.628634,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 154,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "テグ,大邱",
		"name": "BAO BAO ISSEY MIYAKE SHINSEGAE DAEGU",
		"tel": "+82-53-661-6427",
		"fax": "",
		"zipcode": "-",
		"address": "4F, 149, Dongbu-ro, Dong-gu, Daegu, 41229",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 250,
		"shop_code": 159,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Daejeon",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 36.352333,
		"longitude": 127.378547,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 155,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "me ISSEY MIYAKE",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "テジョン,大田",
		"name": "PLEATS PLEASE ISSEY MIYAKE GALLERIA TIMEWORLD",
		"tel": "+82-42-720-6297",
		"fax": "",
		"zipcode": "-",
		"address": "2F, 211, Daedeok-daero, Seo-gu, Daejeon, 35229",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 949,
		"shop_code": 283,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tejon",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 36.377716,
		"longitude": 127.384272,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 156,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "me ISSEY MIYAKE",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "テジョン,大田",
		"name": "PLEATS PLEASE ISSEY MIYAKE SHINSEGAE ART&SCIENCE",
		"tel": "+82-42-607-8226",
		"fax": "",
		"zipcode": "-",
		"address": "17, Expo-ro, Yuseong-gu, Daejeon, 34126",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 948,
		"shop_code": 282,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tejon",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 36.377716,
		"longitude": 127.384272,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 157,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "テジョン,大田",
		"name": "BAO BAO ISSEY MIYAKE SHINSEGAE ART&SCIENCE",
		"tel": "+82-42-607-8220",
		"fax": "",
		"zipcode": "-",
		"address": "17, Expo-ro, Yuseong-gu, Daejeon, 34126",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1008,
		"shop_code": 306,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Daejeon,Daejeon",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 36.377716,
		"longitude": 127.384272,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 158,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "テジョン,大田",
		"name": "HOMME PLISSÉ ISSEY MIYAKE SHINSEGAE ART&SCIENCE",
		"tel": "+82-42-607-8266",
		"fax": "",
		"zipcode": "-",
		"address": "2F, 1 Expo-ro, Yuseong-gu, Daejeon, 34126",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 247,
		"shop_code": 156,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Gyeonggido",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.667988,
		"longitude": 126.752098,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 159,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "キョンギド,京畿道",
		"name": "ISSEY MIYAKE HYUNDAI KINTEX",
		"tel": "+82-31-822-3277",
		"fax": "",
		"zipcode": "-",
		"address": "2F, 817, Hosu-ro, Ilsanseo-gu, Goyang-si, Gyeonggi-do, 10391",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 248,
		"shop_code": 157,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Gyeonggido",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.667907,
		"longitude": 126.752286,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 160,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "BAO BAO ISSEY MIYAKE",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "キョンギド,京畿道",
		"name": "PLEATS PLEASE ISSEY MIYAKE HYUNDAI KINTEX",
		"tel": "+82-31-822-3278",
		"fax": "",
		"zipcode": "-",
		"address": "2F, 817, Hosu-ro, Ilsanseo-gu, Goyang-si, Gyeonggi-do, 10391",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 249,
		"shop_code": 158,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Gyeonggido",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.39246,
		"longitude": 127.112433,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 161,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "キョンギド,京畿道",
		"name": "ISSEY MIYAKE HYUNDAI PANGYO",
		"tel": "+82-31-5170-1268",
		"fax": "",
		"zipcode": "-",
		"address": "2F, 20, Pangyoyeok-ro 146beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, 13529",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 553,
		"shop_code": 199,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Kyunggido",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.39246,
		"longitude": 127.111591,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 162,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "BAO BAO ISSEY MIYAKE",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "キョンギド,京畿道",
		"name": "PLEATS PLEASE ISSEY MIYAKE HYUNDAI PANGYO",
		"tel": "+82-31-5170-1273",
		"fax": "",
		"zipcode": "-",
		"address": "2F, 20, Pangyoyeok-ro 146beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, 13529",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 245,
		"shop_code": 154,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Gyeonggido",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.325092,
		"longitude": 127.108136,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 163,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "キョンギド,京畿道",
		"name": "ISSEY MIYAKE SHINSEGAE GYEONGGI",
		"tel": "+82-31-695-1383",
		"fax": "",
		"zipcode": "-",
		"address": "B1, 1285 Jukjeon-dong, Suji-gu, Yongin-si, Gyeonggi-do, 16896",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 246,
		"shop_code": 155,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Gyeonggido",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.325117,
		"longitude": 127.108198,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 164,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "me ISSEY MIYAKE",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "キョンギド,京畿道",
		"name": "PLEATS PLEASE ISSEY MIYAKE SHINSEGAE GYEONGGI",
		"tel": "+82-31-695-1456",
		"fax": "",
		"zipcode": "-",
		"address": "B1, 536, Poeun-daero, Suji-gu, Yongin-si, Gyeonggi-do, 16896",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 951,
		"shop_code": 285,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Kyunggido",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 37.325117,
		"longitude": 127.108198,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 165,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "キョンギド,京畿道",
		"name": "BAO BAO ISSEY MIYAKE SHINSEGAE GYEONGGI",
		"tel": "+82-31-695-1244",
		"fax": "",
		"zipcode": "-",
		"address": "B1, 536, Poeun-daero, Suji-gu, Yongin-si, Gyeonggi-do, 16896",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 507,
		"shop_code": 178,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Gwangju",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.15446,
		"longitude": 126.912274,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 166,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "クァンジュ,光州",
		"name": "BAO BAO ISSEY MIYAKE LOTTE GWANGJU",
		"tel": "+82-62-221-1170",
		"fax": "",
		"zipcode": "-",
		"address": "1F, 268, Dongnip-ro, Dong-gu, Gwangju, 61470",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 686,
		"shop_code": 226,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Kwangju",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.16043,
		"longitude": 126.87983,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 167,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "me ISSEY MIYAKE",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "クァンジュ,光州",
		"name": "PLEATS PLEASE ISSEY MIYAKE SHINSEGAE GWANGJU",
		"tel": "+82-62-360-1399",
		"fax": "",
		"zipcode": "-",
		"address": "3F, 932, Mujin-daero, Seo-gu, Gwangju, 61937",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 270,
		"shop_code": 172,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Ulsan",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 35.539622,
		"longitude": 129.335854,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 168,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "BAO BAO ISSEY MIYAKE",
		"brand3": "me ISSEY MIYAKE",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ウルサン,蔚山",
		"name": "PLEATS PLEASE ISSEY MIYAKE HYUNDAI ULSAN",
		"tel": "+82-52-228-0470",
		"fax": "",
		"zipcode": "-",
		"address": "2F, 261, Samsan-ro, Nam-gu, Ulsan, 44705",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 185,
		"shop_code": 106,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Taichung City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 24.15271,
		"longitude": 120.662811,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 169,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "132 5. ISSEY MIYAKE",
		"brand3": "PLEATS PLEASE ISSEY MIYAKE",
		"brand4": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand5": "BAO BAO ISSEY MIYAKE",
		"brand6": "me ISSEY MIYAKE",
		"brand7": "ISSEY MIYAKE PARFUMS",
		"brand8": "ISSEY MIYAKE WATCH",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台中",
		"name": "ISSEY MIYAKE TAICHUNG",
		"tel": "+886-4-3704-7755",
		"fax": "",
		"zipcode": "-",
		"address": "No.245, Jhongsing St, West Dist., Taichung City 403",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 571,
		"shop_code": 211,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Taichung City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 24.160638,
		"longitude": 120.642524,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 170,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台中",
		"name": "PLEATS PLEASE ISSEY MIYAKE SHIZHENG",
		"tel": "+886-4-3707-7980",
		"fax": "",
		"zipcode": "-",
		"address": "1F, No.36, Shihjheng N. 2nd Rd., Situn Dist., Taichung City 407",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 573,
		"shop_code": 213,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Taichung City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 24.160735,
		"longitude": 120.642531,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 171,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台中",
		"name": "HOMME PLISSÉ ISSEY MIYAKE SHIZHENG",
		"tel": "+886-4-3707-7980",
		"fax": "",
		"zipcode": "-",
		"address": "2F, No.36, Shihjheng N. 2nd Rd., Situn Dist., Taichung City 407",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 574,
		"shop_code": 214,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Taichung City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 24.160761,
		"longitude": 120.642528,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 172,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台中",
		"name": "BAO BAO ISSEY MIYAKE SHIZHENG",
		"tel": "+886-4-3707-7980",
		"fax": "",
		"zipcode": "-",
		"address": "1F, No.36, Shihjheng N. 2nd Rd., Situn Dist., Taichung City 407",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 572,
		"shop_code": 212,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Taichung City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 24.160775,
		"longitude": 120.642455,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 173,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台中",
		"name": "me ISSEY MIYAKE SHIZHENG",
		"tel": "+886-4-3707-7980",
		"fax": "",
		"zipcode": "-",
		"address": "2F, No.36, Shihjheng N. 2nd Rd., Situn Dist., Taichung City 407",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 511,
		"shop_code": 180,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Taichung City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 24.165025,
		"longitude": 120.643679,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 174,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台中",
		"name": "PLEATS PLEASE ISSEY MIYAKE SHIN KONG MITSUKOSHI TAICHUNG ZHONGGANG",
		"tel": "+886-4-3704-8950",
		"fax": "",
		"zipcode": "-",
		"address": "3F, No.301, Sec. 3, Taiwan Blvd., Situn Dist., Taichung City 407",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 187,
		"shop_code": 107,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Taichung City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 24.164535,
		"longitude": 120.644704,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 175,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台中",
		"name": "PLEATS PLEASE ISSEY MIYAKE TAICHUNG TOP CITY",
		"tel": "+886-4-3704-7861",
		"fax": "",
		"zipcode": "-",
		"address": "3F, No.251, Sec. 3 Taiwan Boulevard, Situn Dist., Taichung City 407",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 189,
		"shop_code": 109,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Taichung City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 24.16449,
		"longitude": 120.644582,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 176,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台中,topcity,台中大远百",
		"name": "me ISSEY MIYAKE TAICHUNG TOP CITY",
		"tel": "+886-4-3704-7714",
		"fax": "",
		"zipcode": "-",
		"address": "3F, No.251, Sec. 3 Taiwan Boulevard, Situn Dist., Taichung City 407",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1001,
		"shop_code": 299,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Taipei City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 25.0829206868131,
		"longitude": 121.557594262861,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 177,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台北,忠泰楽生活",
		"name": "me ISSEY MIYAKE NOKE",
		"tel": "+886-9551-29760",
		"fax": "",
		"zipcode": "-",
		"address": "1F, No. 200, Lequn 3rd Rd, Zhongshan Dist., Taipei City 104",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1030,
		"shop_code": 338,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Taipei City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 25.033419,
		"longitude": 121.564922,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 178,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台北",
		"name": "ISSEY MIYAKE TAIPEI 101 MALL",
		"tel": "+886-903-136-786",
		"fax": "",
		"zipcode": "-",
		"address": "2F, NO.45, Shifu Rd., Xinyi Dist., Taipei City 110",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 931,
		"shop_code": 280,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Taipei City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 25.033419,
		"longitude": 121.564922,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 179,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台北",
		"name": "PLEATS PLEASE ISSEY MIYAKE TAIPEI 101 MALL",
		"tel": "+886-981200122",
		"fax": "",
		"zipcode": "-",
		"address": "No.45, Shihfu Rd, Sinyi District, Taipei City 110",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1029,
		"shop_code": 337,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Taipei City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 25.033419,
		"longitude": 121.564922,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 180,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台北",
		"name": "HOMME PLISSÉ ISSEY MIYAKE TAIPEI 101 MALL",
		"tel": "+886-903-136-787",
		"fax": "",
		"zipcode": "-",
		"address": "2F, NO.45, Shifu Rd., Xinyi Dist., Taipei City 110",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1014,
		"shop_code": 312,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tainan City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 25.033419,
		"longitude": 121.564922,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 181,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台北",
		"name": "BAO BAO  ISSEY MIYAKE TAIPEI 101 MALL",
		"tel": "+886-903-217-127",
		"fax": "",
		"zipcode": "-",
		"address": "2F, NO.45, Shifu Rd., Xinyi Dist., Taipei City 110",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 841,
		"shop_code": 256,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Taipei City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 25.05418118,
		"longitude": 121.5240242,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 182,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台北",
		"name": "ISSEY MIYAKE REGENT GALLERIA",
		"tel": "+886-2-7713-4832",
		"fax": "",
		"zipcode": "-",
		"address": "B2, No. 3, Ln. 39, Sec. 2, Zhongshan N. Rd., Zhongshan Dist., Taipei City 104",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1021,
		"shop_code": 319,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Taipei City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 25.05418118,
		"longitude": 121.5240242,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 183,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "IM MEN",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台北",
		"name": "IM MEN REGENT GALLERIA",
		"tel": "+886-9-5512-9150",
		"fax": "",
		"zipcode": "-",
		"address": "B2, No. 3, Ln. 39, Sec. 2, Zhongshan N. Rd., Zhongshan Dist., Taipei City 104",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 843,
		"shop_code": 257,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Taipei City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 25.05415734,
		"longitude": 121.5242523,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 184,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "132 5. ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台北",
		"name": "132 5. ISSEY MIYAKE REGENT GALLERIA",
		"tel": "+886-2-7713-4831",
		"fax": "",
		"zipcode": "-",
		"address": "B2, No. 3, Ln. 39, Sec. 2, Zhongshan N. Rd., Zhongshan Dist., Taipei City 104",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 897,
		"shop_code": 272,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Taipei City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 25.05414073,
		"longitude": 121.5244452,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 185,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand2": "ISSEY MIYAKE PARFUMS",
		"brand3": "ISSEY MIYAKE WATCH",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台北",
		"name": "HOMME PLISSÉ ISSEY MIYAKE REGENT GALLERIA",
		"tel": "+886-2-7713-4833",
		"fax": "",
		"zipcode": "-",
		"address": "B2, No. 3, Ln. 39, Sec. 2, Zhongshan N. Rd., Zhongshan Dist., Taipei City 104",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 947,
		"shop_code": 281,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Taipei City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 25.05418,
		"longitude": 121.5238,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 186,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台北",
		"name": "BAO BAO ISSEY MIYAKE TAIPEI REGENT GALLERIA",
		"tel": "+886-9-0322-7350",
		"fax": "",
		"zipcode": "-",
		"address": "B2, No. 3, Ln. 39, Sec. 2, Zhongshan N. Rd., Zhongshan Dist., Taipei City 104",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 748,
		"shop_code": 235,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Taipei",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 25.034562,
		"longitude": 121.566529,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 187,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台北",
		"name": "me ISSEY MIYAKE BREEZE NANSHAN",
		"tel": "+886-2-7709-6806",
		"fax": "",
		"zipcode": "-",
		"address": "2F, No.17, Songjhih Rd., Sinyi Dist., Taipei City 110",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 178,
		"shop_code": 102,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Taipei City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 25.040539,
		"longitude": 121.566831,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 188,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台北,breeze,微風,xinyi,信义",
		"name": "HOMME PLISSÉ ISSEY MIYAKE BREEZE XIN YI",
		"tel": "+886-9-0388-0269",
		"fax": "",
		"zipcode": "-",
		"address": "3F, No.68, Sec. 5, Jhongsiao E. Rd., Sinyi Dist., Taipei City 110",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 970,
		"shop_code": 291,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Taipei City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 25.03697785,
		"longitude": 121.567869,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 190,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台北,信义",
		"name": "BAO BAO ISSEY MIYAKE FEDS XINYI A13",
		"tel": "+886-0900-309907",
		"fax": "",
		"zipcode": "-",
		"address": "1F, No.58, Songren Rd., Xinyi Dist., Taipei City 110",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1018,
		"shop_code": 316,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Taipei City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 25.03697785,
		"longitude": 121.567869,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 191,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台北,信义",
		"name": "me ISSEY MIYAKE FEDS XINYI A13",
		"tel": "+886-0955-129592",
		"fax": "",
		"zipcode": "-",
		"address": "2F, No.58, Songren Rd., Xinyi Dist., Taipei City 110",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 577,
		"shop_code": 217,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Taipei City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 25.039783,
		"longitude": 121.56654,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 192,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台北",
		"name": "PLEATS PLEASE ISSEY MIYAKE SHIN KONG MITSUKOSHI A4",
		"tel": "+886-2-7709-7884",
		"fax": "",
		"zipcode": "-",
		"address": "3F, No.19, Songgao Rd., Sinyi Dist., Taipei City 110",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 578,
		"shop_code": 218,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Taipei City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 25.036536,
		"longitude": 121.566684,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 193,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台北",
		"name": "BAO BAO ISSEY MIYAKE SHIN KONG MITSUKOSHI A9",
		"tel": "+886-2-7730-4565",
		"fax": "",
		"zipcode": "-",
		"address": "2F, No.9, Songshou Rd., Sinyi Dist., Taipei City 110",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 903,
		"shop_code": 277,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Taipei City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 25.05214654,
		"longitude": 121.521116,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 194,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台北",
		"name": "me ISSEY MIYAKE NANXI",
		"tel": "+886-903-500272",
		"fax": "",
		"zipcode": "-",
		"address": "2F., No. 12, Nanjing W. Rd., Zhongshan Dist., Taipei City 104",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 172,
		"shop_code": 96,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Taipei City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 25.04111,
		"longitude": 121.543154,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 195,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台北,sogo,fuxing,復興館",
		"name": "PLEATS PLEASE ISSEY MIYAKE SOGO FUXING",
		"tel": "+886-2-7709-8861",
		"fax": "",
		"zipcode": "-",
		"address": "4F, No.300, Sec. 3, Jhongsiao E. Rd., Da'an Dist., Taipei City 106",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 174,
		"shop_code": 98,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Taipei City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 25.041093,
		"longitude": 121.542856,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 196,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台北,sogo,fuxing,復興館",
		"name": "BAO BAO ISSEY MIYAKE SOGO FUXING",
		"tel": "+886-2-7730-8480",
		"fax": "",
		"zipcode": "-",
		"address": "1F, No.300, Sec. 3, Jhongsiao E. Rd., Da'an Dist., Taipei City 106",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 173,
		"shop_code": 97,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Taipei City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 25.041227,
		"longitude": 121.543148,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 197,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台北,sogo,fuxing,復興館",
		"name": "me ISSEY MIYAKE SOGO FUXING",
		"tel": "+886-903-500233",
		"fax": "",
		"zipcode": "-",
		"address": "4F, No.300, Sec. 3, Jhongsiao E. Rd., Da'an Dist., Taipei City 106",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 190,
		"shop_code": 110,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Chiayi City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 23.496388,
		"longitude": 120.452543,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 198,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "嘉義,嘉义",
		"name": "PLEATS PLEASE ISSEY MIYAKE NICE PLAZA",
		"tel": "+886-5-320-9999",
		"fax": "",
		"zipcode": "-",
		"address": "1F, No.600, Jhungsiao Rd, East Dist., Chiayi City 600",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 848,
		"shop_code": 262,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Hsinchu City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 24.810092,
		"longitude": 120.975112,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 199,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "新竹,sogo",
		"name": "BAO BAO ISSEY MIYAKE FAR EASTERN SOGO HSINCHU STORE",
		"tel": "+886-3-623-5199",
		"fax": "",
		"zipcode": "-",
		"address": "1F, No.239, Zhongyang Rd., East Dist., Hsinchu City 300",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 847,
		"shop_code": 261,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Hsinchu City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 24.809742,
		"longitude": 120.975847,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 200,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "新竹,sogo",
		"name": "me ISSEY MIYAKE FAR EASTERN SOGO HSINCHU",
		"tel": "+886-3-623-5008",
		"fax": "",
		"zipcode": "-",
		"address": "1F, No.239, Zhongyang Rd., East Dist., Hsinchu City 300",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 199,
		"shop_code": 115,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Kaohsiung City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 22.669735,
		"longitude": 120.302361,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 201,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "高雄,hanshin,漢神,漢神百貨",
		"name": "PLEATS PLEASE ISSEY MIYAKE HANSHIN ARENA SHOPPING PLAZA",
		"tel": "+886-7-974-1752",
		"fax": "",
		"zipcode": "-",
		"address": "2F, No.777, Bo Ai 2nd Rd., Zuoying Dist., Kaohsiung City 813",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 201,
		"shop_code": 117,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Kaohsiung City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 22.6697255,
		"longitude": 120.30231,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 202,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "高雄,hanshin,漢神,漢神百貨",
		"name": "BAO BAO ISSEY MIYAKE HANSHIN ARENA SHOPPING PLAZA",
		"tel": "+886-7-976-8778",
		"fax": "",
		"zipcode": "-",
		"address": "1F, No.777, Bo Ai 2nd Rd., Zuoying Dist., Kaohsiung City 813",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 200,
		"shop_code": 116,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Kaohsiung City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 22.669587,
		"longitude": 120.302327,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 203,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "高雄,hanshin,漢神,漢神百貨",
		"name": "me ISSEY MIYAKE HANSHIN ARENA SHOPPING PLAZA",
		"tel": "+886-7-974-1760",
		"fax": "",
		"zipcode": "-",
		"address": "2F, No.777, Bo Ai 2nd Rd., Zuoying Dist., Kaohsiung City 813",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 194,
		"shop_code": 112,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Kaohsiung City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 22.619562,
		"longitude": 120.296321,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 204,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "高雄,hanshin,漢神,漢神百貨",
		"name": "PLEATS PLEASE ISSEY MIYAKE HAN SHIN",
		"tel": "+886-7-973-4300",
		"fax": "",
		"zipcode": "-",
		"address": "4F, No.266-1, Chenggong 1st Rd, Cianjin Dist., Kaohsiung City 801",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 566,
		"shop_code": 207,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Kaohsiung City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 22.619284,
		"longitude": 120.296362,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 205,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "高雄,hanshin,漢神,漢神百貨",
		"name": "HOMME PLISSÉ ISSEY MIYAKE HAN SHIN",
		"tel": "+886-7-973-4300",
		"fax": "",
		"zipcode": "-",
		"address": "4F, No.266-1, Chenggong 1st Rd, Cianjin Dist., Kaohsiung City 801",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 195,
		"shop_code": 113,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Kaohsiung City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 22.61922,
		"longitude": 120.296042,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 206,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "高雄,hanshin,漢神,漢神百貨",
		"name": "me ISSEY MIYAKE HAN SHIN",
		"tel": "+886-7-973-4300",
		"fax": "",
		"zipcode": "-",
		"address": "4F, No.266-1, Chenggong 1st Rd, Cianjin Dist., Kaohsiung City 801",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1017,
		"shop_code": 315,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Kaohsiung City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 22.65594,
		"longitude": 120.30644,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 207,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "高雄",
		"name": "ISSEY MIYAKE E SKY MALL",
		"tel": "+886-981-929798",
		"fax": "",
		"zipcode": "-",
		"address": "1F, No.115, Dashun 1st Rd, Gushan District, Kaohsiung City 804",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1036,
		"shop_code": 344,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Kaohsiung City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 22.65594,
		"longitude": 120.30644,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 208,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "IM MEN",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "高雄",
		"name": "IM MEN E SKY MALL",
		"tel": "+886-989-717123",
		"fax": "",
		"zipcode": "-",
		"address": "1F, No.115, Dashun 1st Rd, Gushan District, Kaohsiung City 804",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1037,
		"shop_code": 345,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Kaohsiung City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 22.65594,
		"longitude": 120.30644,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 209,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "高雄",
		"name": "HOMME PLISSÉ ISSEY MIYAKE E SKY MALL",
		"tel": "+886-936-891632",
		"fax": "",
		"zipcode": "-",
		"address": "1F, No.115, Dashun 1st Rd, Gushan District, Kaohsiung City 804",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1035,
		"shop_code": 343,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Kaohsiung City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 22.65594,
		"longitude": 120.30644,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 210,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "高雄",
		"name": "BAO BAO ISSEY MIYAKE E SKY MALL",
		"tel": "+886-900-015535",
		"fax": "",
		"zipcode": "-",
		"address": "1F, No.115, Dashun 1st Rd, Gushan District, Kaohsiung City 804",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1007,
		"shop_code": 305,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Kaohsiung City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 22.65594,
		"longitude": 120.30644,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 211,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "高雄",
		"name": "me ISSEY MIYAKE E SKY MALL",
		"tel": "+886-9897-97123",
		"fax": "",
		"zipcode": "-",
		"address": "2F, No.115, Dashun 1st Rd, Gushan District, Kaohsiung City 804",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 180,
		"shop_code": 103,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "New Taipei City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 25.014011,
		"longitude": 121.46727,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 212,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "新北,板橋,板桥,板桥大远百",
		"name": "PLEATS PLEASE ISSEY MIYAKE FAR EASTERN BANQIAO",
		"tel": "+886-0903-202-123",
		"fax": "",
		"zipcode": "-",
		"address": "3F, No.28, Xinzhan Road, Banqiao Dist., New Taipei City 220",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 874,
		"shop_code": 268,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tainan City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 22.990813,
		"longitude": 120.232713,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 213,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台南",
		"name": "PLEATS PLEASE ISSEY MIYAKE T.S. Mall",
		"tel": "+886-903-215622",
		"fax": "",
		"zipcode": "-",
		"address": "1F, No. 366, Sec. 1, Zhonghua E. Rd., East Dist., Tainan City 701",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 875,
		"shop_code": 269,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tainan City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 22.991189,
		"longitude": 120.232917,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 214,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台南",
		"name": "me ISSEY MIYAKE T.S. Mall",
		"tel": "+886-903-215622",
		"fax": "",
		"zipcode": "-",
		"address": "1F, No. 366, Sec. 1, Zhonghua E. Rd., East Dist., Tainan City 701",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 780,
		"shop_code": 244,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tainan City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 22.986793,
		"longitude": 120.198703,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 215,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台南",
		"name": "PLEATS PLEASE ISSEY MIYAKE SHIN KONG MITSUKOSHI TAINAN PLACE",
		"tel": "+886-6-703-0329",
		"fax": "",
		"zipcode": "-",
		"address": "1F, No.658, Sec. 1, Simen Rd., West Central Dist., Tainan City 700",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 779,
		"shop_code": 243,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tainan City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 22.986743,
		"longitude": 120.198451,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 216,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台南",
		"name": "HOMME PLISSÉ ISSEY MIYAKE SHIN KONG MITSUKOSHI TAINAN PLACE",
		"tel": "+886-6-703-0326",
		"fax": "",
		"zipcode": "-",
		"address": "1F, No.658, Sec. 1, Simen Rd., West Central Dist., Tainan City 700",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 564,
		"shop_code": 206,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tainan City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 22.986776,
		"longitude": 120.198556,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 217,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台南",
		"name": "BAO BAO ISSEY MIYAKE SHIN KONG MITSUKOSHI TAINAN PLACE",
		"tel": "+886-6-703-0488",
		"fax": "",
		"zipcode": "-",
		"address": "1F, No.658, Sec. 1, Simen Rd., West Central Dist., Tainan City 700",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 778,
		"shop_code": 242,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Tainan City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 22.98674,
		"longitude": 120.198719,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 218,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "台南",
		"name": "me ISSEY MIYAKE SHIN KONG MITSUKOSHI TAINAN PLACE",
		"tel": "+886-6-703-0327",
		"fax": "",
		"zipcode": "-",
		"address": "1F, No.658, Sec. 1, Simen Rd., West Central Dist., Tainan City 700",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 964,
		"shop_code": 289,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Jukbuk City",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 24.82235603,
		"longitude": 121.0232649,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 219,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "竹北",
		"name": "PLEATS PLEASE ISSEY MIYAKE FEDS ZHUBEI",
		"tel": "+886-0900-288-252",
		"fax": "",
		"zipcode": "-",
		"address": "1F, No.18, Zhuangjing N. Rd., Zhubei City 302",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 202,
		"shop_code": 118,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Beijing",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 39.909879,
		"longitude": 116.478787,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 220,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "BAO BAO ISSEY MIYAKE",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "北京,skp",
		"name": "ISSEY MIYAKE SKP BEIJING",
		"tel": "+86-10-6500-2331",
		"fax": "",
		"zipcode": "-",
		"address": "D3021, 3F, BEIJING HUALIAN (SKP), No.87 Jianguo Road, Chaoyang District, Beijing",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 204,
		"shop_code": 119,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Beijing",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 39.910207,
		"longitude": 116.478702,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 221,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "北京,skp",
		"name": "PLEATS PLEASE ISSEY MIYAKE SKP BEIJING",
		"tel": "+86-10-6500-0225",
		"fax": "",
		"zipcode": "-",
		"address": "B1034, B1, BEIJING HUALIAN (SKP), No.87 Jianguo Road, Chaoyang District, Beijing",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1025,
		"shop_code": 333,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Beijing",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 39.910267,
		"longitude": 116.459073,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 222,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "IM MEN",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "北京",
		"name": "IM MEN CHINA WORLD MALL",
		"tel": "+86-10-6505-8785",
		"fax": "",
		"zipcode": "-",
		"address": "NL3033, L3, North Area, China World Mall, No.1 Jianguomenwai Avenue, Chaoyang District, Beijing",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 205,
		"shop_code": 120,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Beijing",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 39.910242,
		"longitude": 116.458987,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 223,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "北京",
		"name": "PLEATS PLEASE ISSEY MIYAKE CHINA WORLD MALL",
		"tel": "+86-10-6505-8786",
		"fax": "",
		"zipcode": "-",
		"address": "NL3032, L3, North Area, China World Mall, No.1 Jianguomenwai Avenue, Chaoyang District, Beijing",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 531,
		"shop_code": 189,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Beijing",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 39.910267,
		"longitude": 116.459073,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 224,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "北京",
		"name": "HOMME PLISSÉ ISSEY MIYAKE CHINA WORLD MALL",
		"tel": "+86-10-6505-8785",
		"fax": "",
		"zipcode": "-",
		"address": "NL3033, L3, North Area, China World Mall, No.1 Jianguomenwai Avenue, Chaoyang District, Beijing",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 696,
		"shop_code": 231,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Beijing",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 39.910294,
		"longitude": 116.459021,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 225,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "北京",
		"name": "BAO BAO ISSEY MIYAKE CHINA WORLD MALL",
		"tel": "+86-10-6505-8786",
		"fax": "",
		"zipcode": "-",
		"address": "NL3032, L3, North Area, China World Mall, No.1 Jianguomenwai Avenue, Chaoyang District, Beijing",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1010,
		"shop_code": 308,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Beijing",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 39.93431,
		"longitude": 116.45462,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 226,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "PLEATS PLEASE ISSEY MIYAKE",
		"brand3": "BAO BAO ISSEY MIYAKE",
		"brand4": "me ISSEY MIYAKE",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "北京",
		"name": "ISSEY MIYAKE TAIKOO LI SANLITUN",
		"tel": "+86-10-8400-4184",
		"fax": "",
		"zipcode": "-",
		"address": "S6-12, S6-21a-1, Taikoo Li Sanlitun South Beijing",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1028,
		"shop_code": 336,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Beijing",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 39.93431,
		"longitude": 116.45462,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 227,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "北京",
		"name": "HOMME PLISSÉ ISSEY MIYAKE TAIKOO LI SANLITUN",
		"tel": "+86-10-6865-8005",
		"fax": "",
		"zipcode": "-",
		"address": "S6-11C, Taikoo Li Sanlitun South, No. 19 Sanlitun Road, Chaoyang District, Beijing",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 997,
		"shop_code": 296,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Chengdu",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 30.59256098,
		"longitude": 104.06724593,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 228,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "成都,skp",
		"name": "ISSEY MIYAKE CHENGDU SKP",
		"tel": "+86-28-6083-1653",
		"fax": "",
		"zipcode": "-",
		"address": "No.2001, North section of Tianfu Avenue, Hi-tech Indust Development Zone, Chengdu",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 217,
		"shop_code": 129,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Chengdu",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 30.654728,
		"longitude": 104.08315,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 229,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "me ISSEY MIYAKE",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "成都,太古里",
		"name": "PLEATS PLEASE ISSEY MIYAKE TAIKOO LI CHENGDU",
		"tel": "+86-28-8592-0349",
		"fax": "",
		"zipcode": "-",
		"address": "No.1252a, Taikoo Li Chengdu, Zhongshamao Road No 8, Jinjiang District, Chengdu",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1009,
		"shop_code": 307,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Chengdu, Chengdu",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 30.654728,
		"longitude": 104.08315,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 230,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "成都,太古里",
		"name": "HOMME PLISSÉ ISSEY MIYAKE TAIKOO LI CHENGDU",
		"tel": "+86-28-8670-2785",
		"fax": "",
		"zipcode": "-",
		"address": "No.1334, Taikoo Li Chengdu, Zhongshamao Road No. 8, Jinjiang District, Chengdu",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 788,
		"shop_code": 250,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Chengdu",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 30.65336751,
		"longitude": 104.0834698,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 231,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "成都,太古里",
		"name": "BAO BAO ISSEY MIYAKE TAIKOO LI CHENGDU",
		"tel": "+86-28-8592-0349",
		"fax": "",
		"zipcode": "-",
		"address": "No.1252a+2228, Taikoo Li Chengdu, Zhongshamao Road No 8, Jinjiang District, Chengdu",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 995,
		"shop_code": 294,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Guangzhou",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 23.13487699,
		"longitude": 113.33217432,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 232,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "BAO BAO ISSEY MIYAKE",
		"brand3": "me ISSEY MIYAKE",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "広州,广州,太古汇",
		"name": "PLEATS PLEASE ISSEY MIYAKE GUANGZHOU TAIKOO HUI",
		"tel": "+86-20-2211-6270",
		"fax": "",
		"zipcode": "-",
		"address": "Unit MU51, Guangzhou Taikoo Hui, No.383 Tianhe Road, Huaxin Community, Tianhe District, Guangzhou",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 996,
		"shop_code": 295,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Guangzhou",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 23.13487699,
		"longitude": 113.33217432,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 233,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "BAO BAO ISSEY MIYAKE",
		"brand3": "me ISSEY MIYAKE",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "広州,广州,太古汇",
		"name": "BAO BAO ISSEY MIYAKE GUANGZHOU TAIKOO HUI",
		"tel": "+86-20-2211-6270",
		"fax": "",
		"zipcode": "-",
		"address": "Unit MU51, Guangzhou Taikoo Hui, No.383 Tianhe Road, Huaxin Community, Tianhe District, Guangzhou",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 641,
		"shop_code": 219,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Hangzhou",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 30.272532,
		"longitude": 120.161397,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 234,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "杭州",
		"name": "PLEATS PLEASE ISSEY MIYAKE HANGZHOU TOWER",
		"tel": "+86-571-8680-2086",
		"fax": "",
		"zipcode": "-",
		"address": "2F, Tower C, Hangzhou Tower, No.1 Wulin Square, Xiacheng District, Hangzhou",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 642,
		"shop_code": 215,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Hangzhou",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 30.272532,
		"longitude": 120.161397,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 235,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "杭州",
		"name": "BAO BAO ISSEY MIYAKE HANGZHOU TOWER",
		"tel": "+86-571-8680-2086",
		"fax": "",
		"zipcode": "-",
		"address": "2F, Tower C, Hangzhou Tower, No.1 Wulin Square, Xiacheng District, Hangzhou",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 213,
		"shop_code": 127,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Nanjing",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 32.0403759674593,
		"longitude": 118.781203963818,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 236,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "me ISSEY MIYAKE",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "南京",
		"name": "PLEATS PLEASE ISSEY MIYAKE JLC",
		"tel": "+86-025-8881-6659",
		"fax": "",
		"zipcode": "-",
		"address": "L1-02b, JLC West, No. 29 Wangfu Street, Qinhuai District, Nanjing, Jiangsu Province",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1022,
		"shop_code": 320,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Nanjing",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 32.0403759674593,
		"longitude": 118.781203963818,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 237,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "南京",
		"name": "BAO BAO ISSEY MIYAKE JLC",
		"tel": "+86-025-8881-6659",
		"fax": "",
		"zipcode": "-",
		"address": "L1-02b, JLC West, No. 29 Wangfu Street, Qinhuai District, Nanjing, Jiangsu Province",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 208,
		"shop_code": 123,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Shanghai",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 31.224302,
		"longitude": 121.450216,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 238,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "BAO BAO ISSEY MIYAKE",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "上海",
		"name": "ISSEY MIYAKE SHANGHAI KERRY CENTRE",
		"tel": "+86-21-6241-6178",
		"fax": "",
		"zipcode": "-",
		"address": "N1-02B, 1F, Shanghai Jing An Kerry Centre No.1515, Najing West Road, Jingan District, Shanghai",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 210,
		"shop_code": 125,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Shanghai",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 31.236713,
		"longitude": 121.501925,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 239,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "上海",
		"name": "PLEATS PLEASE ISSEY MIYAKE SHANGHAI IFC",
		"tel": "+86-21-6858-5809",
		"fax": "",
		"zipcode": "-",
		"address": "B1, LG1-50, SHANGHAI ifc Mall, Shiji Dadao Road No.8, Pudong New Area, Shanghai",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 536,
		"shop_code": 193,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Shanghai",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 31.23687,
		"longitude": 121.501852,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 240,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "上海",
		"name": "BAO BAO ISSEY MIYAKE SHANGHAI IFC",
		"tel": "+86-21-6858-5809",
		"fax": "",
		"zipcode": "-",
		"address": "B1, LG1-50, SHANGHAI ifc Mall, Shiji Dadao Road No.8, Pudong New Area, Shanghai",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 211,
		"shop_code": 126,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Shanghai",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 31.230668,
		"longitude": 121.462734,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 241,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "上海",
		"name": "PLEATS PLEASE ISSEY MIYAKE SHANGHAI TAIKOO HUI",
		"tel": "+86-21-6289-6099",
		"fax": "",
		"zipcode": "-",
		"address": "2F, L204, HKRI TAIKOO HUI, Shimen 1st Road No.288, Jing'an District, Shanghai",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 873,
		"shop_code": 267,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Shanghai",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 31.230713,
		"longitude": 121.462706,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 242,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "上海,太古汇",
		"name": "HOMME PLISSÉ ISSEY MIYAKE SHANGHAI TAIKOO HUI",
		"tel": "+86-21-6233-7137",
		"fax": "",
		"zipcode": "-",
		"address": "1F, N140, HKRI TAIKOO HUI, Shimen 1st Road No.288, Jing'an District, Shanghai",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 697,
		"shop_code": 232,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Shanghai",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 31.230666,
		"longitude": 121.462679,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 243,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "上海,太古汇",
		"name": "BAO BAO ISSEY MIYAKE SHANGHAI TAIKOO HUI",
		"tel": "+86-21-6237-2398",
		"fax": "",
		"zipcode": "-",
		"address": "1F, N142, HKRI TAIKOO HUI, Shimen 1st Road No.288, Jing'an District, Shanghai",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 537,
		"shop_code": 194,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Shanghai",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 31.230744,
		"longitude": 121.462573,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 244,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "上海,太古汇",
		"name": "me ISSEY MIYAKE SHANGHAI TAIKOO HUI",
		"tel": "+86-21-6289-6099",
		"fax": "",
		"zipcode": "-",
		"address": "2F, L204, HKRI TAIKOO HUI, Shimen 1st Road No.288, Jing'an District, Shanghai",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 215,
		"shop_code": 128,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Shenzhen",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 22.541155,
		"longitude": 114.110852,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 245,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "me ISSEY MIYAKE",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "深圳",
		"name": "PLEATS PLEASE ISSEY MIYAKE THE MIX CITY SHENZHEN",
		"tel": "+86-755-2215-2467",
		"fax": "",
		"zipcode": "-",
		"address": "No.343/345, The Mix City, No.1881 Bao'an South Road, Luohu District, Shenzhen",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 544,
		"shop_code": 197,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Shenzhen",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 22.541377,
		"longitude": 114.110957,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 246,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "深圳",
		"name": "BAO BAO ISSEY MIYAKE THE MIX CITY SHENZHEN",
		"tel": "+86-755-2215-2467",
		"fax": "",
		"zipcode": "-",
		"address": "No.343/345, The Mix City, No.1881 Bao'an South Road, Luohu District, Shenzhen",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 568,
		"shop_code": 208,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Shenzhen",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 22.5396563,
		"longitude": 114.1106611,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 247,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "深圳",
		"name": "PLEATS PLEASE ISSEY MIYAKE SHENZHEN MIX CITY WORLD SHOPPING MALL",
		"tel": "+86-755-8668-0025",
		"fax": "",
		"zipcode": "-",
		"address": "No.22, LG, The Mix City World, Shennan Avenue, Nanshan District, Shenzhen",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 569,
		"shop_code": 209,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Shenzhen",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 22.539712,
		"longitude": 114.111123,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 248,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "深圳",
		"name": "HOMME PLISSÉ ISSEY MIYAKE SHENZHEN MIX CITY WORLD SHOPPING MALL",
		"tel": "+86-755-8668-0025",
		"fax": "",
		"zipcode": "-",
		"address": "No.22, LG, The Mix City World, Shennan Avenue, Nanshan District, Shenzhen",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 570,
		"shop_code": 210,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Shenzhen",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 22.539326,
		"longitude": 114.111027,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 249,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "深圳",
		"name": "BAO BAO ISSEY MIYAKE SHENZHEN MIX CITY WORLD SHOPPING MALL",
		"tel": "+86-755-8668-0025",
		"fax": "",
		"zipcode": "-",
		"address": "No.22, LG, The Mix City World, Shennan Avenue, Nanshan District, Shenzhen",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 930,
		"shop_code": 279,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Xian",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 34.22173324,
		"longitude": 108.8967524,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 250,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "PLEATS PLEASE ISSEY MIYAKE",
		"brand3": "me ISSEY MIYAKE",
		"brand4": "BAO BAO ISSEY MIYAKE",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "西安",
		"name": "ISSEY MIYAKE ZHONGDA INTERNATIONAL SHOPPING MALL",
		"tel": "+86-29-8881-7234",
		"fax": "",
		"zipcode": "-",
		"address": "1F, L123, ZHONGDA INTERNATIONAL SHOPPING MALL, Gaoxin Road No.72, Xi'an",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 221,
		"shop_code": 132,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Hong Kong",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 22.297476,
		"longitude": 114.168513,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 251,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "IM MEN",
		"brand3": "132 5. ISSEY MIYAKE",
		"brand4": "PLEATS PLEASE ISSEY MIYAKE",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "香港",
		"name": "ISSEY MIYAKE HARBOUR CITY",
		"tel": "+852-2110-1372",
		"fax": "",
		"zipcode": "-",
		"address": "Shop 102&102A, Level 1, Ocean Centre, Harbour City, Tsim Sha Tsui, Kowloon, Hong Kong",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 560,
		"shop_code": 202,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Hong Kong",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 22.295874,
		"longitude": 114.168637,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 252,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "香港",
		"name": "HOMME PLISSÉ ISSEY MIYAKE HARBOUR CITY",
		"tel": "+852-2110-1421",
		"fax": "",
		"zipcode": "-",
		"address": "Shop 238, L2, Ocean Centre, Harbour City, Tsim Sha Tsui, Kowloon, Hong Kong",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 219,
		"shop_code": 130,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Hong Kong",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 22.295911,
		"longitude": 114.168861,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 253,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "香港",
		"name": "BAO BAO ISSEY MIYAKE HARBOUR CITY",
		"tel": "+852-2114-0617",
		"fax": "",
		"zipcode": "-",
		"address": "Shop 117A, L1, Ocean Centre, Harbour City, Tsim Sha Tsui, Kowloon, Hong Kong",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 222,
		"shop_code": 133,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Hong Kong",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 22.280417,
		"longitude": 114.184176,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 254,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "me ISSEY MIYAKE",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "香港,sogo",
		"name": "PLEATS PLEASE ISSEY MIYAKE SOGO HONG KONG",
		"tel": "+852-2831-3919",
		"fax": "",
		"zipcode": "-",
		"address": "1/F SOGO, Causeway Bay, Hong Kong",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 952,
		"shop_code": 286,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Hong Kong",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 22.280417,
		"longitude": 114.184176,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 255,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "香港",
		"name": "BAO BAO ISSEY MIYAKE SOGO HONG KONG",
		"tel": "+852-2831-3997",
		"fax": "",
		"zipcode": "-",
		"address": "1/F SOGO, Causeway Bay, Hong Kong",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1011,
		"shop_code": 309,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Hong Kong",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 22.29435,
		"longitude": 114.175065,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 256,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "香港",
		"name": "me ISSEY MIYAKE K11 MUSEA",
		"tel": "+852-3102-2081",
		"fax": "",
		"zipcode": "-",
		"address": "Location 216, 2F, K11 MUSEA, Victoria Dockside, 18 Salisbury Road, Tsim Sha Tsui",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 153,
		"shop_code": 84,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Bangkok",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 13.74633,
		"longitude": 100.531676,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 257,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "132 5. ISSEY MIYAKE",
		"brand3": "PLEATS PLEASE ISSEY MIYAKE",
		"brand4": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand5": "BAO BAO ISSEY MIYAKE",
		"brand6": "me ISSEY MIYAKE",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "バンコク,曼谷",
		"name": "ISSEY MIYAKE SIAM DISCOVERY",
		"tel": "+662-021-2141-2",
		"fax": "",
		"zipcode": "-",
		"address": "989 Rama 1 Road, Pathumwan, Bangkok 10330",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 523,
		"shop_code": 186,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Bangkok",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 13.744586,
		"longitude": 100.544557,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 258,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "バンコク,曼谷,chidlom",
		"name": "PLEATS PLEASE ISSEY MIYAKE CENTRAL CHIDLOM",
		"tel": "+662-655-7752",
		"fax": "",
		"zipcode": "-",
		"address": "1027 Ploenchit Road, Lumpini, Pathumwan, Bangkok 10330",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 155,
		"shop_code": 86,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Bangkok",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 13.744395,
		"longitude": 100.54444,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 259,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "バンコク,曼谷,chidlom",
		"name": "BAO BAO ISSEY MIYAKE CENTRAL CHIDLOM",
		"tel": "+662-655-7562",
		"fax": "",
		"zipcode": "-",
		"address": "1027 Ploenchit Road, Lumpini, Pathumwan, Bangkok 10330",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 156,
		"shop_code": 87,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Bangkok",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 13.815818,
		"longitude": 100.560955,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 260,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "バンコク,曼谷",
		"name": "BAO BAO ISSEY MIYAKE CENTRAL LADPRAO",
		"tel": "+662-541-1534",
		"fax": "",
		"zipcode": "-",
		"address": "1691 Phaholyothin Road, Chatuchak, Bangkok 10900",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 522,
		"shop_code": 185,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Bangkok",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 13.731089,
		"longitude": 100.569558,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 261,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "バンコク,曼谷,emquartier",
		"name": "PLEATS PLEASE ISSEY MIYAKE THE EMQUARTIER",
		"tel": "+662-021-2177",
		"fax": "",
		"zipcode": "-",
		"address": "693, 695 Sukhumvit Road, Watthana, Bangkok 10110",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1000,
		"shop_code": 298,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Bangkok",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 13.73109525,
		"longitude": 100.56986698,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 262,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "バンコク,曼谷,emquartier",
		"name": "HOMME PLISSÉ ISSEY MIYAKE THE EMQUARTIER",
		"tel": "+662-021-2109",
		"fax": "",
		"zipcode": "-",
		"address": "689, Sukhumvit Road, Wattana, Bangkok 10110",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 154,
		"shop_code": 85,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Bangkok",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 13.731174,
		"longitude": 100.569579,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 263,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "バンコク,曼谷,emquartier",
		"name": "BAO BAO ISSEY MIYAKE THE EMQUARTIER",
		"tel": "+662-021-2177",
		"fax": "",
		"zipcode": "-",
		"address": "693, 695 Sukhumvit Road, Watthana, Bangkok 10110",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1002,
		"shop_code": 300,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Bangkok",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 13.7310278523454,
		"longitude": 100.569775922117,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 264,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "バンコク,曼谷,emquartier",
		"name": "me ISSEY MIYAKE THE EMQUARTIER",
		"tel": "+662-021-2100",
		"fax": "",
		"zipcode": "-",
		"address": "689, Sukhumvit Road, Wattana, Bangkok 10110",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1026,
		"shop_code": 334,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Bangkok",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 13.726876,
		"longitude": 100.509937,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 265,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "me ISSEY MIYAKE",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "バンコク,曼谷,iconsiam",
		"name": "PLEATS PLEASE ISSEY MIYAKE ICONSIAM",
		"tel": "+662-021-2179",
		"fax": "",
		"zipcode": "-",
		"address": "M Floor, Siam Takashimaya ICONSIAM, 299 Soi Charoen Nakhon 5, Charoen Nakhon Road, Khlong Ton Sai, Khlong San, Bangkok 10600",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1038,
		"shop_code": 346,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Bangkok",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 13.726876,
		"longitude": 100.509937,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 266,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "バンコク,曼谷,iconsiam",
		"name": "HOMME PLISSÉ ISSEY MIYAKE ICONSIAM",
		"tel": "+662-021-2178",
		"fax": "",
		"zipcode": "-",
		"address": "M Floor, Siam Takashimaya ICONSIAM, 299 Soi Charoen Nakhon 5, Charoen Nakhon Road, Khlong Ton Sai, Khlong San, Bangkok 10600",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1027,
		"shop_code": 335,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Bangkok",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 13.726876,
		"longitude": 100.509937,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 267,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "バンコク,曼谷,iconsiam",
		"name": "BAO BAO ISSEY MIYAKE ICONSIAM",
		"tel": "+662-021-2179",
		"fax": "",
		"zipcode": "-",
		"address": "M Floor, Siam Takashimaya ICONSIAM, 299 Soi Charoen Nakhon 5, Charoen Nakhon Road, Khlong Ton Sai, Khlong San, Bangkok 10600",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 148,
		"shop_code": 79,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Singapore",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 1.305934,
		"longitude": 103.82942,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 268,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "IM MEN",
		"brand3": "132 5. ISSEY MIYAKE",
		"brand4": "PLEATS PLEASE ISSEY MIYAKE",
		"brand5": "BAO BAO ISSEY MIYAKE",
		"brand6": "me ISSEY MIYAKE",
		"brand7": "ISSEY MIYAKE EYES",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "シンガポール,新加坡",
		"name": "ISSEY MIYAKE VOCO HOTEL",
		"tel": "+65-6304-1352",
		"fax": "",
		"zipcode": "-",
		"address": "02-05/10 Voco Hotel Singapore, 581 Orchard Road, Singapore 238883",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 151,
		"shop_code": 82,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Singapore",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 1.302656,
		"longitude": 103.835086,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 269,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "シンガポール,新加坡",
		"name": "PLEATS PLEASE ISSEY MIYAKE TAKASHIMAYA",
		"tel": "+65-6304-1358",
		"fax": "",
		"zipcode": "-",
		"address": "L2 Takashimaya Department Store, 391A Orchard Road, Ngee Ann City, Singapore 238873",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 521,
		"shop_code": 184,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Singapore",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 1.302613,
		"longitude": 103.835161,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 270,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "シンガポール,新加坡",
		"name": "BAO BAO ISSEY MIYAKE TAKASHIMAYA",
		"tel": "+65-6304-1358",
		"fax": "",
		"zipcode": "-",
		"address": "L2 Takashimaya Department Store, 391A Orchard Road, Ngee Ann City, Singapore 238873",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 1033,
		"shop_code": 341,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Singapore",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 1.302656,
		"longitude": 103.835086,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 271,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "me ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "シンガポール,新加坡",
		"name": "me ISSEY MIYAKE TAKASHIMAYA",
		"tel": "+65-6304-1358",
		"fax": "",
		"zipcode": "-",
		"address": "L2 Takashimaya Department Store, 391A Orchard Road, Ngee Ann City, Singapore 238873",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 150,
		"shop_code": 81,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Singapore",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 1.285403,
		"longitude": 103.859559,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 272,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "me ISSEY MIYAKE",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "シンガポール,新加坡",
		"name": "PLEATS PLEASE ISSEY MIYAKE MARINA BAY SANDS",
		"tel": "+65-6304-1480",
		"fax": "",
		"zipcode": "-",
		"address": "01-17 The Shoppes at Marina Bay Sands, 2 Bayfront Avenue, Singapore 018972",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 519,
		"shop_code": 182,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Singapore",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 1.285357,
		"longitude": 103.859609,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 273,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "シンガポール,新加坡",
		"name": "HOMME PLISSÉ ISSEY MIYAKE MARINA BAY SANDS",
		"tel": "+65-6304-1480",
		"fax": "",
		"zipcode": "-",
		"address": "01-17 The Shoppes at Marina Bay Sands, 2 Bayfront Avenue, Singapore 018972",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 520,
		"shop_code": 183,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Singapore",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 1.285361,
		"longitude": 103.859502,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 274,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "BAO BAO ISSEY MIYAKE",
		"brand2": "",
		"brand3": "",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "シンガポール,新加坡",
		"name": "BAO BAO ISSEY MIYAKE MARINA BAY SANDS",
		"tel": "+65-6304-1480",
		"fax": "",
		"zipcode": "-",
		"address": "01-17 The Shoppes at Marina Bay Sands, 2 Bayfront Avenue, Singapore 018972",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 994,
		"shop_code": 293,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Kuala Lumpur",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 3.11889408,
		"longitude": 101.67624538,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 275,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "PLEATS PLEASE ISSEY MIYAKE",
		"brand3": "BAO BAO ISSEY MIYAKE",
		"brand4": "me ISSEY MIYAKE",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "クアラルンプール,吉隆坡",
		"name": "ISSEY MIYAKE THE GARDENS MALL",
		"tel": "+60-3-2201-5581",
		"fax": "",
		"zipcode": "-",
		"address": "Lot G-206, Ground Floor, The Gardens Mall, Mid Valley City Lingkaran Syed Putra, 59200 Kuala Lumpur",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 513,
		"shop_code": 181,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Kuala Lumpur",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 3.148773,
		"longitude": 101.713503,
		"google_business_url": "",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 276,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "ISSEY MIYAKE",
		"brand2": "PLEATS PLEASE ISSEY MIYAKE",
		"brand3": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand4": "BAO BAO ISSEY MIYAKE",
		"brand5": "me ISSEY MIYAKE",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "クアラルンプール,吉隆坡",
		"name": "ISSEY MIYAKE PAVILION",
		"tel": "+60-3-2729-0676",
		"fax": "",
		"zipcode": "-",
		"address": "Lot 2.26.00 & 2.38.00, Level 2 & Level 3, Pavillion Kuala Lumpur, 168 Jalan Bukit Bintang, 55100 Kuala Lumpur",
		"description": "",
		"store_hours": "",
		"description_note": ""
	},
	{
		"id": 563,
		"shop_code": 205,
		"country_id": "",
		"country_name": "",
		"prefecture_id": "",
		"city_id": "",
		"city_name": "Dubai",
		"has_members": false,
		"is_flagship": false,
		"is_street": "",
		"is_shop_in_shop": "",
		"is_member_ship_point": false,
		"is_reservation": false,
		"latitude": 25.198826,
		"longitude": 55.279605,
		"google_business_url": "NULL",
		"prefecture_name": "",
		"img1": "NULL",
		"img2": "NULL",
		"img3": "NULL",
		"img4": "NULL",
		"img5": "NULL",
		"img6": "NULL",
		"flagship_img": "",
		"position": 277,
		"is_visible": "",
		"facebook_url": "",
		"twitter_url": "",
		"instagram_url": "",
		"pinterest_url": "",
		"weibo_url": "",
		"line_url": "",
		"brand1": "PLEATS PLEASE ISSEY MIYAKE",
		"brand2": "HOMME PLISSÉ ISSEY MIYAKE",
		"brand3": "BAO BAO ISSEY MIYAKE",
		"brand4": "",
		"brand5": "",
		"brand6": "",
		"brand7": "",
		"brand8": "",
		"brand9": "",
		"brand10": "",
		"brand11": "",
		"brand12": "",
		"brand13": "",
		"brand14": "",
		"brand15": "",
		"gallery": "",
		"keyword": "ドバイ,杜拜",
		"name": "PLEATS PLEASE ISSEY MIYAKE DUBAI MALL",
		"tel": "+82-2-2163-1290",
		"fax": "",
		"zipcode": "-",
		"address": "GF, Fashion Avenue, The Dubai Mall, Financial Center Road",
		"description": "",
		"store_hours": "",
		"description_note": ""
	}
]